// 21hermosa 피부 진단 & 루틴 추천 앱 코어 스크립트 (성분 매칭 및 다중선택 전면 개정본)

// ==================== 1. EmailJS 실제 이메일 발송 설정 ====================
// emailjs.com 무료 가입 → Email Services → Gmail 연결 → Email Templates 생성
// Template 변수: {{to_name}}, {{to_email}}, {{skin_type}}, {{skin_desc}}, {{concern}}, {{result_link}}
const EMAILJS_CONFIG = {
  PUBLIC_KEY:  "stnWU_vd7Q6_cqkUk",
  SERVICE_ID:  "service_vhg25ws",
  TEMPLATE_ID: "template_j2ufr8d"
};

// ==================== 1b. Google Sheets 통계 연동 ====================
// 설치: google-apps-script.js 파일을 Google Apps Script에 붙여넣고
// 웹앱으로 배포한 후 아래 URL을 교체하세요.
const SHEETS_URL = 'https://script.google.com/macros/s/AKfycbxrhfX9JZF3L2TIQCtpYll-pDC2o5RsBnOkET8Wc0zVoURxP3KI57VV80zFS7K5iwKM/exec';

function sendToGoogleSheets(data) {
  if (!SHEETS_URL || SHEETS_URL === 'YOUR_APPS_SCRIPT_URL_HERE') return;
  try {
    const url = SHEETS_URL + '?payload=' + encodeURIComponent(JSON.stringify(data));
    console.log('[Sheets] 전송:', data);
    fetch(url, { mode: 'no-cors' }).catch(() => {});
  } catch (e) { console.error('[Sheets] 오류:', e); }
}

if (typeof emailjs !== 'undefined' && EMAILJS_CONFIG.PUBLIC_KEY) {
  emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
}

// ==================== 1c. 개인정보처리방침 URL ====================
// ⚠️ Shopify 기본 경로. 실제 정책 페이지 핸들이 다르면 교체하세요.
const PRIVACY_URL = 'https://21hermosa.es/policies/privacy-policy';

// ==================== 1d. Klaviyo 연동 (마케팅 / 결과 메일) ====================
// 클라이언트사이드 REST API. 공개키(Site ID)만 사용 → 브라우저 노출 OK.
//   PUBLIC_KEY: Klaviyo → Settings → API Keys → Public API Key (6자리)
//   LIST_ID:    구독시킬 뉴스레터 리스트 ID (Lists & Segments → 리스트 → Settings)
//   ⚠️ 두 값을 채워야 Klaviyo가 활성화됩니다. 비어있으면 EmailJS 폴백으로 동작.
const KLAVIYO_CONFIG = {
  PUBLIC_KEY: 'UdiM6h',    // 21hermosa Klaviyo Public API Key (Site ID)
  LIST_ID:    'XiYg5f',    // 메인 마케팅 리스트(온라인몰 동의 회원). 출처는 custom_source='Skin Quiz'로 구분
  REVISION:   '2024-10-15',
  // 결과 메일 Flow를 트리거할 이벤트 이름 (Klaviyo Flow Trigger에서 동일하게 사용)
  EVENT_NAME: 'Completed Skin Quiz'
};

function klaviyoConfigured() { return !!KLAVIYO_CONFIG.PUBLIC_KEY; }

// 이벤트 전송 → 프로필 생성/갱신 + 'Completed Skin Quiz' 이벤트 기록 → 결과 메일 Flow 트리거
function sendKlaviyoEvent(profile, properties) {
  if (!klaviyoConfigured()) return Promise.resolve(false);
  const body = {
    data: {
      type: 'event',
      attributes: {
        properties: properties || {},
        metric:  { data: { type: 'metric',  attributes: { name: KLAVIYO_CONFIG.EVENT_NAME } } },
        profile: { data: { type: 'profile', attributes: profile } }
      }
    }
  };
  return fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(KLAVIYO_CONFIG.PUBLIC_KEY)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_CONFIG.REVISION },
    body: JSON.stringify(body)
  }).then(r => r.ok || Promise.reject(r.status)).catch(e => { console.error('[Klaviyo event]', e); return false; });
}

// 마케팅 구독 동의 → 리스트 구독 (리스트에 더블옵트인 켜져 있으면 Klaviyo가 확인메일 자동 발송)
function subscribeKlaviyo(email, firstName) {
  if (!klaviyoConfigured() || !KLAVIYO_CONFIG.LIST_ID) return Promise.resolve(false);
  const body = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Skin Quiz',
        profile: { data: { type: 'profile', attributes: {
          email: email,
          first_name: firstName || '',
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: KLAVIYO_CONFIG.LIST_ID } } }
    }
  };
  return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(KLAVIYO_CONFIG.PUBLIC_KEY)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_CONFIG.REVISION },
    body: JSON.stringify(body)
  }).then(r => r.ok || Promise.reject(r.status)).catch(e => { console.error('[Klaviyo subscribe]', e); return false; });
}

// ==================== 2. 다국어 사전 (i18n Dictionary) ====================
const i18n = {
  es: {
    intro_title: "Descubre tu ritual perfecto de K-Beauty",
    intro_subtitle: "Encuentra tu tipo de piel exacto y obtén una rutina personalizada de 5 pasos basada en ingredientes activos adaptados a tus necesidades biológicas.",
    intro_btn: "Comenzar Diagnóstico",
    next: "Siguiente",
    lead_title: "¡Diagnóstico Completado!",
    lead_desc: "Introduce tu correo electrónico para generar tu diagnóstico personalizado y la guía de cuidado K-Beauty completa de forma gratuita.",
    lead_btn: "Obtener Mi Ritual",
    water_title: "Paso 1: Limpieza con agua templada",
    water_desc: "Para tu tipo de piel seca o sensible, se recomienda evitar los limpiadores jabonosos por la mañana para proteger la barrera cutánea. Limpia solo con agua tibia.",
    help_title: "¿Tienes dudas sobre tu rutina?",
    help_desc: "Haz una captura de pantalla de este diagnóstico o copia el enlace y envíanos un mensaje por Instagram DM (@21hermosa.es) para recibir asesoramiento personalizado gratuito.",
    help_btn: "Copiar Enlace de Resultado",
    secret_text: "© 2026 21hermosa Parafarmacia. Todos los derechos reservados.",
    other_options: "Otras opciones recomendadas con este ingrediente",
    email_cta_label: "Recibe tu tipo de piel + rutina personalizada por email 💌",
    email_cta_sub: "Te enviamos tu diagnóstico completo y una guía de cuidado K-Beauty gratis.",
    email_cta_placeholder: "tu@correo.com",
    email_cta_btn: "Quiero recibirlo",
    email_cta_sending: "Enviando...",
    email_cta_invalid: "Por favor, introduce un correo electrónico válido.",
    email_cta_consent: "Quiero recibir consejos de cuidado y novedades de 21hermosa por email (opcional).",
    email_cta_privacy: "Usaremos tu correo para enviarte tu diagnóstico. Consulta nuestra",
    email_cta_privacy_link: "Política de Privacidad",
    email_sent_ok: "¡Enviado! Revisa tu correo 💌",
    comprar: "Añadir al carrito",
    skin_dry: "Piel Seca",
    skin_oily: "Piel Grasa",
    skin_combo: "Piel Mixta",
    skin_sensitive: "Piel Sensible",
    desc_dry: "Tu piel tiene una barrera debilitada por falta de lípidos y agua. Necesitas nutrición, texturas ricas e ingredientes reparadores como la ceramida y el ginseng.",
    desc_oily: "Tu piel produce exceso de sebo. Necesitas equilibrar la grasa, limpiar los poros a fondo y aportar hidratación ligera con texturas tipo gel o agua.",
    desc_combo: "Tienes la Zona T grasa y las mejillas secas. Necesitas un equilibrio de hidratación por capas, controlando el sebo en unas áreas y nutriendo otras.",
    desc_sensitive: "Tu piel es reactiva, se enrojece con facilidad y tiene la barrera dañada. Necesitas fórmulas hipoalergénicas, sin perfume, ricas en centella asiática y pantenol.",
    advice_title: "Consejo experto para ti:",
    recommended_ing: "Ingrediente Activo Recomendado:",
    save_image: "Guardar como Imagen"
  },
  en: {
    intro_title: "Discover your perfect K-Beauty ritual",
    intro_subtitle: "Find your exact skin type and get a personalized 5-step routine based on active ingredients tailored to your biological needs.",
    intro_btn: "Start Diagnosis",
    next: "Next",
    lead_title: "Diagnosis Completed!",
    lead_desc: "Enter your email address to generate your personalized diagnosis and complete K-Beauty care guide for free.",
    lead_btn: "Get My Ritual",
    water_title: "Step 1: Lukewarm Water Wash",
    water_desc: "For your dry or sensitive skin, it is highly recommended to avoid foaming cleansers in the morning to protect the skin barrier. Cleanse only with warm water.",
    help_title: "Have questions about your routine?",
    help_desc: "Take a screenshot of this diagnosis or copy the link and send us a message on Instagram DM (@21hermosa.es) for free expert advice.",
    help_btn: "Copy Result Link",
    secret_text: "© 2026 21hermosa Parafarmacia. All rights reserved.",
    other_options: "Other options recommended with this ingredient",
    email_cta_label: "Get your skin type + personalized routine by email 💌",
    email_cta_sub: "We'll send your full diagnosis and a free K-Beauty care guide.",
    email_cta_placeholder: "you@email.com",
    email_cta_btn: "Send it to me",
    email_cta_sending: "Sending...",
    email_cta_invalid: "Please enter a valid email address.",
    email_cta_consent: "I'd like to receive skincare tips and news from 21hermosa by email (optional).",
    email_cta_privacy: "We'll use your email to send your diagnosis. See our",
    email_cta_privacy_link: "Privacy Policy",
    email_sent_ok: "Sent! Check your inbox 💌",
    comprar: "Add to cart",
    skin_dry: "Dry Skin",
    skin_oily: "Oily Skin",
    skin_combo: "Combination Skin",
    skin_sensitive: "Sensitive Skin",
    desc_dry: "Your skin barrier is weakened due to a lack of lipids and moisture. You need deep nutrition, rich textures, and skin-repairing ingredients like ceramides and ginseng.",
    desc_oily: "Your skin produces excess sebum. You need to balance oil production, deeply clear out pores, and add lightweight hydration using gel or watery textures.",
    desc_combo: "You have an oily T-Zone and dry cheeks. You need layered hydration that balances oil in some areas while deeply nourishing others.",
    desc_sensitive: "Your skin is highly reactive, easily flushed, and has a compromised barrier. You need fragrance-free, hypoallergenic formulas rich in centella asiatica and pantenol.",
    advice_title: "Expert advice for you:",
    recommended_ing: "Recommended Active Ingredient:",
    save_image: "Save as Image"
  },
  ko: {
    intro_title: "나만을 위한 K-Beauty 완벽 루틴 찾기",
    intro_subtitle: "정교한 피부 타입 진단을 거쳐, 당신의 연령과 고민에 꼭 맞는 실제 K-Beauty 5단계 맞춤 제품 루틴을 즉시 제안받으세요.",
    intro_btn: "피부 진단 시작하기",
    next: "다음 단계",
    lead_title: "피부 진단 완료!",
    lead_desc: "개인화된 피부 분석서 및 21hermosa K-Beauty 홈케어 가이드라인을 무료로 받아보실 이메일 주소를 입력해 주세요.",
    lead_btn: "맞춤 루틴 확인하기",
    water_title: "Paso 1: 미온수 물세안",
    water_desc: "당신의 피부 타입(건성/민감성)은 아침에 폼클렌저 세안 시 피부 보호막이 손상될 수 있습니다. 아침에는 자극 없는 미온수 물세안을 강력히 추천합니다.",
    help_title: "이 루틴에 대해 궁금한 점이 있으신가요?",
    help_desc: "결과 화면을 캡처하거나 링크를 복사하여 인스타그램 DM(@21hermosa.es)으로 보내주시면 스킨케어 전문가가 무료 상담을 도와드립니다.",
    help_btn: "진단 결과 링크 복사하기",
    secret_text: "© 2026 21hermosa Parafarmacia. 모든 권리 보유.",
    other_options: "다른 추천 제품",
    email_cta_label: "내 피부 타입 결과 + 맞춤 루틴을 이메일로 받기 💌",
    email_cta_sub: "전체 진단서와 K-Beauty 홈케어 가이드를 무료로 이메일로 보내드려요.",
    email_cta_placeholder: "이메일 주소를 입력하세요",
    email_cta_btn: "이메일로 받기",
    email_cta_sending: "보내는 중...",
    email_cta_invalid: "올바른 이메일 주소를 입력해 주세요.",
    email_cta_consent: "21hermosa의 스킨케어 팁과 소식을 이메일로 받는 데 동의합니다 (선택).",
    email_cta_privacy: "입력하신 이메일은 진단 결과 발송에 사용됩니다. 자세한 내용은",
    email_cta_privacy_link: "개인정보처리방침",
    email_sent_ok: "발송 완료! 메일함을 확인해 주세요 💌",
    comprar: "장바구니에 담기",
    skin_dry: "건성 피부",
    skin_oily: "지성 피부",
    skin_combo: "복합성 피부",
    skin_sensitive: "민감성 피부",
    desc_dry: "피부의 유수분이 모두 부족하여 쉽게 푸석해지고 장벽이 약화된 상태입니다. 세라마이드, 인삼 추출물 등 장벽 보호 및 강력 고보습 영양 공급이 필수적입니다.",
    desc_oily: "피지 분비가 왕성하여 번들거림과 트러블이 잦은 상태입니다. 과도한 유분을 조절하고 모공을 케어하는 가볍고 산뜻한 젤/수분 제형의 제품이 적합합니다.",
    desc_combo: "T존(이마, 코)은 피지 분비로 지성이며 볼(U존)은 건조한 상태입니다. 유분 관리가 필요한 부위와 보습이 필요한 부위의 밸런스를 맞추는 단계적 레이어링이 중요합니다.",
    desc_sensitive: "피부 장벽이 얇고 손상되어 외부 자극이나 화장품 변화에 쉽게 붉어지고 따가운 상태입니다. 무향 저자극 포뮬러와 병풀(센텔라), 판테놀 성분의 완화제가 필수적입니다.",
    advice_title: "스킨케어 전문가 처방:",
    recommended_ing: "추천 활성 성분:",
    save_image: "이미지로 저장하기"
  }
};

// ==================== 3. 상태 관리 (State Management) ====================
let currentLang = 'es';
let currentQuestionIdx = -1; // -1: Intro
let userName = '';
let userAge = '';
let answers = {};
let detectedSkinType = '';
let selectedRoutineTab = 'dia';
let selectedTier = 'completo'; // 'esencial' | 'recomendado' | 'completo' — 기본값은 기존 동작과 동일(전체 표시)
let _pendingSheetData = null;
let _pendingSheetSent = false;   // 중복 전송 방지 플래그
let _recommendedProductListAM = [];
let _recommendedProductListPM = [];

// ==================== 4. 다국어 제어 (i18n Translation) ====================
function switchLanguage(lang) {
  currentLang = lang;
  
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.classList.remove('active');
    if (btn.innerText.toLowerCase() === lang) {
      btn.classList.add('active');
    }
  });

  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (i18n[lang][key]) {
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.setAttribute('placeholder', i18n[lang][key]);
      } else {
        el.innerText = i18n[lang][key];
      }
    }
  });

  if (currentQuestionIdx >= 0 && currentQuestionIdx < window.skinQuestions.length) {
    renderQuestion(currentQuestionIdx);
  }

  if (detectedSkinType) {
    renderResult();
  }
}

// ==================== 5. 설문 흐름 제어 (Survey Navigation) ====================
function startSurvey() {
  currentQuestionIdx = 0;
  answers = {};
  
  document.getElementById('intro-view').style.display = 'none';
  document.getElementById('survey-view').style.display = 'flex';
  document.getElementById('progress-container').style.display = 'block';
  
  renderQuestion(currentQuestionIdx);
}

function updateProgressBar() {
  const total = window.skinQuestions.length;
  const percent = ((currentQuestionIdx) / total) * 100;
  document.getElementById('progress-bar').style.width = percent + '%';
}

function renderQuestion(index) {
  updateProgressBar();
  const q = window.skinQuestions[index];
  
  const btnBack = document.getElementById('btn-back');
  btnBack.style.visibility = index > 0 ? 'visible' : 'hidden';

  const qText = q.question[currentLang] || q.question['es'];
  document.getElementById('question-text').innerText = qText;

  const contentArea = document.getElementById('question-content');
  contentArea.innerHTML = '';

  // 1) 텍스트형 입력 (이름)
  if (q.type === 'text') {
    const placeholder = q.placeholder[currentLang] || q.placeholder['es'];
    contentArea.innerHTML = `
      <input type="text" id="name-input" class="input-text" placeholder="${placeholder}" value="${userName}">
    `;
    document.getElementById('name-input').addEventListener('keypress', function(e) {
      if (e.key === 'Enter') nextQuestion();
    });
  } 
  // 2) 단일 선택형 라디오
  else if (q.type === 'radio') {
    const listDiv = document.createElement('div');
    listDiv.className = 'options-list';
    
    q.options.forEach(opt => {
      const isSelected = answers[q.id] === opt.value || (q.id === 'q2_age' && userAge === opt.value);
      const card = document.createElement('div');
      card.className = `option-card ${isSelected ? 'selected' : ''}`;
      card.onclick = () => selectOption(q.id, opt.value, card);

      const optText = opt.text[currentLang] || opt.text['es'];
      card.innerHTML = `
        <div class="option-circle"></div>
        <div class="option-text">${optText}</div>
      `;
      listDiv.appendChild(card);
    });
    contentArea.appendChild(listDiv);
  }
  // 3) 체크박스 (maxSelect 지원)
  else if (q.type === 'checkbox') {
    const listDiv = document.createElement('div');
    listDiv.className = 'options-list';
    const maxSel = q.maxSelect || Infinity;

    function _refreshCheckboxCards() {
      const sels = answers[q.id] || [];
      listDiv.querySelectorAll('.option-card').forEach(card => {
        card.classList.toggle('selected', sels.includes(card.dataset.optValue));
      });
    }

    q.options.forEach(opt => {
      const currentSelections = answers[q.id] || [];
      const isSelected = currentSelections.includes(opt.value);
      const card = document.createElement('div');
      card.className = `option-card ${isSelected ? 'selected' : ''}`;
      card.dataset.optValue = opt.value;

      card.onclick = () => {
        // "해당 사항 없음"(skip) → 필터 비우고 바로 다음 단계로
        if (opt.skip) {
          answers[q.id] = [];
          card.classList.add('selected');
          setTimeout(() => nextQuestion(), 200);
          return;
        }
        let sels = answers[q.id] ? [...answers[q.id]] : [];
        if (sels.includes(opt.value)) {
          sels = sels.filter(v => v !== opt.value);
        } else if (sels.length < maxSel) {
          sels.push(opt.value);
        }
        answers[q.id] = sels;
        _refreshCheckboxCards();
        if (maxSel === 1) setTimeout(() => nextQuestion(), 250);
      };

      const optText = opt.text[currentLang] || opt.text['es'];
      card.innerHTML = `
        <div class="option-square"></div>
        <div class="option-text">${optText}</div>
      `;
      listDiv.appendChild(card);
    });
    contentArea.appendChild(listDiv);
  }
}

function selectOption(questionId, value, cardElement) {
  cardElement.parentNode.querySelectorAll('.option-card').forEach(c => {
    c.classList.remove('selected');
  });
  cardElement.classList.add('selected');
  
  if (questionId === 'q2_age') {
    userAge = value;
  } else {
    answers[questionId] = value;
  }

  setTimeout(() => {
    nextQuestion();
  }, 250);
}

function prevQuestion() {
  if (currentQuestionIdx > 0) {
    currentQuestionIdx--;
    renderQuestion(currentQuestionIdx);
  }
}

function nextQuestion() {
  const q = window.skinQuestions[currentQuestionIdx];
  
  // 유효성 체크
  if (q.type === 'text') {
    const val = document.getElementById('name-input').value.trim();
    if (!val) {
      alert(currentLang === 'ko' ? '이름을 입력해 주세요!' : (currentLang === 'en' ? 'Please enter your name!' : '¡Por favor, introduce tu nombre!'));
      return;
    }
    userName = val;
  } else if (q.type === 'radio') {
    const selectedVal = (q.id === 'q2_age') ? userAge : answers[q.id];
    if (!selectedVal) {
      alert(currentLang === 'ko' ? '옵션을 하나 선택해 주세요!' : (currentLang === 'en' ? 'Please select an option!' : '¡Por favor, selecciona una opción!'));
      return;
    }
  } else if (q.type === 'checkbox' && !q.optional) {
    const sels = answers[q.id] || [];
    if (sels.length === 0) {
      alert(currentLang === 'ko' ? '최소 1가지를 선택해 주세요!' : (currentLang === 'en' ? 'Please select at least one option!' : '¡Por favor, selecciona al menos una opción!'));
      return;
    }
  }

  // 마지막 질문 → 리드게이트 없이 바로 결과
  if (currentQuestionIdx === window.skinQuestions.length - 1) {
    document.getElementById('progress-bar').style.width = '100%';
    setTimeout(() => {
      calculateSkinType();
      // 경험 수준 답변에 따라 기본 티어 설정(초보=필수만, 그 외=기존과 동일하게 전체)
      if (answers['q10_experience'] === 'beginner') selectedTier = 'esencial';
      _pendingSheetSent = false;
      _pendingSheetData = {
        name:          userName || '',
        email:         '',
        age:           userAge,
        gender:        answers['q_gender'] || '',
        skinType:      detectedSkinType,
        concern:       answers['q5_concern'],
        safetyFilters: answers['q7_safety_filters'] || [],
        sunscreen:     answers['q8_sunscreen'] || '',
        lang:          currentLang,
        source:        'skinquiz'
      };
      // 안전장치: 10초 안에 전송 안 됐으면 제품 없이 전송
      setTimeout(() => {
        if (_pendingSheetData && !_pendingSheetSent) {
          _pendingSheetSent = true;
          sendToGoogleSheets(_pendingSheetData);
        }
      }, 10000);
      document.getElementById('survey-view').style.display = 'none';
      document.getElementById('progress-container').style.display = 'none';
      document.getElementById('result-view').style.display = 'flex';
      renderResult();
    }, 200);
  } else {
    currentQuestionIdx++;
    renderQuestion(currentQuestionIdx);
  }
}


function sendEmailJS(leadData, onSuccess, onError) {
  // ★ 버그 수정: 피부타입 i18n 키는 'combination' 이 아니라 'combo'
  const skinKey  = leadData.skinType === 'combination' ? 'combo' : leadData.skinType;
  const typeName = i18n[currentLang][`skin_${skinKey}`] || leadData.skinType || '';
  const skinDesc = i18n[currentLang][`desc_${skinKey}`] || '';

  const templateParams = {
    to_name:      leadData.name,
    to_email:     leadData.email,
    subject:      leadData.subject || '21hermosa',
    skin_type:    typeName,
    skin_desc:    skinDesc,
    concern:      leadData.concern,
    routine_text: leadData.routine_text || '',
    email_body:   leadData.email_body || '',   // 전체 HTML 본문 (템플릿에서 {{{email_body}}})
    store_link:   'https://21hermosa.es'
  };

  const isConfigured = EMAILJS_CONFIG.PUBLIC_KEY && EMAILJS_CONFIG.SERVICE_ID && EMAILJS_CONFIG.TEMPLATE_ID;

  if (typeof emailjs !== 'undefined' && isConfigured) {
    emailjs.send(EMAILJS_CONFIG.SERVICE_ID, EMAILJS_CONFIG.TEMPLATE_ID, templateParams)
      .then(() => { if (onSuccess) onSuccess(); })
      .catch(err => {
        console.error('[EmailJS]', err);
        if (onError) onError();
      });
  } else {
    console.log('[EmailJS] Config not set — skipping send. Params:', templateParams);
  }
}

// ==================== 7. 피부 진단 계산 알고리즘 ====================
function calculateSkinType() {
  const scores = { dry: 0, oily: 0, combination: 0, sensitive: 0 };

  const q3Val = answers['q3_after_wash'];
  const q4Val = answers['q4_sebum'];
  const q5Val = answers['q5_concern'];
  const q6Val = answers['q6_sensitivity'];

  const q3Opt = window.skinQuestions.find(q => q.id === 'q3_after_wash').options.find(o => o.value === q3Val);
  if (q3Opt && q3Opt.scores) {
    for (let k in q3Opt.scores) scores[k] += q3Opt.scores[k];
  }

  const q4Opt = window.skinQuestions.find(q => q.id === 'q4_sebum').options.find(o => o.value === q4Val);
  if (q4Opt && q4Opt.scores) {
    for (let k in q4Opt.scores) scores[k] += q4Opt.scores[k];
  }

  const q6Opt = window.skinQuestions.find(q => q.id === 'q6_sensitivity').options.find(o => o.value === q6Val);
  if (q6Opt && q6Opt.scores) {
    for (let k in q6Opt.scores) scores[k] += q6Opt.scores[k];
  }

  // Q5 concern cross-validation: use primary (first selected) concern as skin type signal
  // (보조 신호 — 앞 진단 질문 q3/q4/q6가 주 결정. 홍조는 +1로 완화)
  const q5Primary = Array.isArray(q5Val) ? q5Val[0] : q5Val;
  if (q5Primary === 'redness')                         scores.sensitive += 1;
  if (q5Primary === 'acne' || q5Primary === 'poros')   scores.oily      += 1;
  if (q5Primary === 'dryness')                         scores.dry       += 1;

  if (scores.sensitive >= 5) {
    detectedSkinType = 'sensitive';
  } else {
    let maxVal = -1;
    let type = 'combination';

    ['dry', 'oily', 'combination'].forEach(t => {
      if (scores[t] > maxVal) {
        maxVal = scores[t];
        type = t;
      }
    });
    detectedSkinType = type;
  }
}

// ==================== 8. 성분 기반 2단계 매칭 사전 (Ingredients Prescriptions) ====================
// 피부타입(dry, oily, combination, sensitive) + 고민(dryness, acne, redness, dullness) 매트릭스에 따른 단계별 추천 성분
const ingredientPrescriptions = {
  // Step 1: 클렌저 (오일 또는 페이셜)
  1: {
    dry: { tag: "mineral", name: { es: "Agua de Mar Mineral", en: "Mineral Deep Sea Water", ko: "미네랄 해양 심층수" } },
    oily: { tag: "teatree", name: { es: "Aceite de Árbol de Té", en: "Tea Tree Oil", ko: "티트리 오일" } },
    combination: { tag: "panthenol", name: { es: "Pantenol Balanceante", en: "Balancing Panthenol", ko: "유수분 조절 판테놀" } },
    sensitive: { tag: "centella", name: { es: "Centella de Madagascar", en: "Madagascar Centella", ko: "순수 센텔라(병풀)" } }
  },
  // Step 2: 토너
  2: {
    dry: { tag: "panthenol", name: { es: "Pantenol Altamente Hidratante", en: "Deep Hydrating Panthenol", ko: "고보습 판테놀" } },
    oily: { tag: "heartleaf", name: { es: "77% Extracto de 어성초", en: "77% Soothing Heartleaf", ko: "어성초 추출물 77%" } },
    combination: { tag: "allantoin", name: { es: "Alantoína Calmante", en: "Calming Allantoin", ko: "각질 정돈 알란토인" } },
    sensitive: { tag: "heartleaf", name: { es: "어성초 (Houttuynia)", en: "Heartleaf (Houttuynia)", ko: "어성초 진정수" } }
  },
  // Step 3: 세럼
  3: {
    dry: { tag: "hyaluronic", name: { es: "Ácido Hialurónico de Bajo Peso", en: "Low Molecular Hyaluronic Acid", ko: "저분자 히알루론산" } },
    oily: { tag: "propolis", name: { es: "Propóleo Nutritivo", en: "Balancing Propolis", ko: "피지 케어 프로폴리스" } },
    combination: { tag: "hyaluronic", name: { es: "Ácido Hialurónico", en: "Hyaluronic Acid", ko: "속수분 히알루론산" } },
    sensitive: { tag: "centella", name: { es: "Extracto de Centella pura", en: "Pure Centella Extract", ko: "고농축 병풀 추출물" } }
  },
  // Step 4: 크림
  4: {
    dry: { tag: "snail", name: { es: "Secreción Filtrada de Caracol", en: "Snail Secretion Filtrate", ko: "재생 달팽이 점액" } },
    oily: { tag: "centella", name: { es: "Centella Asiática Ligera", en: "Lightweight Centella Gel", ko: "산뜻한 병풀수 젤" } },
    combination: { tag: "hyaluronic", name: { es: "Capsulas de Ácido Hialurónico", en: "Hyaluronic Acid Capsules", ko: "자작나무 수액 히알루론산" } },
    sensitive: { tag: "madecassoside", name: { es: "Madecassoside Barrera", en: "Madecassoside Barrier", ko: "마데카소사이드 장벽 케어" } }
  },
  // Step 5: 선크림
  5: {
    dry: { tag: "chemicalfilter", name: { es: "Filtro Químico Nutritivo (Arroz)", en: "Organic Sunscreen (Rice Essence)", ko: "촉촉한 에센스 유기 필터" } },
    oily: { tag: "chemicalfilter", name: { es: "Filtro Químico de Rápida Absorción", en: "Fast Absorbing Watery Sunscreen", ko: "눈시림 없는 투명 유기 필터" } },
    combination: { tag: "chemicalfilter", name: { es: "Filtro Químico Hidratante", en: "Water-Fit Organic Sunscreen", ko: "수분 촉촉 가벼운 유기 필터" } },
    sensitive: { tag: "zincoxide", name: { es: "Óxido de Zinc Mineral (Físico)", en: "Zinc Oxide Mineral Filter (Physical)", ko: "논나노 징크옥사이드 무기 필터" } }
  }
};

// ==================== 9. 단계별 피부 교육 텍스트 ====================
const stepWhyTexts = {
  es: {
    1: {
      dry:         "Para piel seca, lo prioritario es no agredir la barrera cutánea. Usa un limpiador de pH bajo que limpie sin resecar ni irritar.",
      oily:        "La piel grasa necesita eliminar el exceso de sebo y limpiar los poros a fondo. Un limpiador formulado para piel grasa regula la producción de sebo.",
      combination: "Para piel mixta, un limpiador suave de pH bajo equilibra la zona T sin resecar las mejillas.",
      sensitive:   "La piel sensible necesita fórmulas sin sulfatos ni fragancias que limpien sin generar irritación ni reactividad."
    },
    2: {
      dry:         "El tónico es el primer aporte de hidratación tras la limpieza. Aplícalo de inmediato para evitar la pérdida de agua transepidérmica.",
      oily:        "El tónico equilibra el pH de la piel y refina los poros — es el paso clave para controlar el sebo antes de aplicar el sérum.",
      combination: "El tónico actúa como base hidratante uniforme, equilibrando la zona T y preparando las mejillas para absorber mejor el sérum.",
      sensitive:   "Un tónico sin fragancia ni alcohol restaura el pH cutáneo y reduce el enrojecimiento sin ningún tipo de irritación."
    },
    3: {
      dry:         "El sérum es la etapa de hidratación concentrada. Sus activos de bajo peso molecular penetran en capas profundas para resolver la deshidratación interna.",
      oily:        "Un sérum específico para piel grasa controla la producción de sebo, refina los poros y previene brotes de forma más precisa que cualquier crema.",
      combination: "Un sérum ligero lleva activos exactamente donde más se necesitan, adaptándose tanto a la zona T como a las mejillas.",
      sensitive:   "Un sérum ultra-calmante repara la barrera cutánea desde el interior y reduce la reactividad sin irritar."
    },
    4: {
      dry:         "La crema hidratante sella toda la hidratación acumulada en los pasos anteriores y aporta los lípidos que la barrera cutánea necesita para recuperarse.",
      oily:        "La piel grasa también necesita hidratación — sin ella, produce más sebo para compensar. Una textura gel aporta agua sin añadir pesadez.",
      combination: "Una crema ligera pero nutritiva es la clave para equilibrar la piel mixta: hidrata las mejillas sin obstruir los poros de la zona T.",
      sensitive:   "Una crema reparadora es el paso más importante para piel sensible: sella los activos calmantes y protege la barrera frente a irritantes externos."
    },
    5: {
      dry:         "El protector solar es el paso anti-envejecimiento más importante. Para piel seca, elige una textura cremosa que hidrate a la vez que protege.",
      oily:        "Un fotoprotector de textura acuosa o tipo sérum se absorbe al instante, sin dejar brillos ni sensación pegajosa en pieles grasas.",
      combination: "Un protector solar water-fit termina con un acabado fresco y ligero, sin remarcar la zona T.",
      sensitive:   "El filtro físico (mineral) refleja los rayos UV sin penetrar en la piel, siendo el más seguro para pieles reactivas o embarazadas."
    }
  },
  en: {
    1: {
      dry:         "Protecting the skin barrier while cleansing is essential for dry skin. A mild, low-pH cleanser removes impurities without stripping natural moisture.",
      oily:        "Deep pore cleansing is the foundation for oily skin. A formula designed for oily skin regulates excess sebum and prevents clogged pores.",
      combination: "A pH-balanced cleanser treats both the oily T-zone and dry cheeks without over-drying or over-moisturizing any area.",
      sensitive:   "Sensitive skin needs sulfate-free, fragrance-free formulas that cleanse gently without triggering redness or reactivity."
    },
    2: {
      dry:         "Apply toner immediately after cleansing to lock in hydration before water evaporates from the skin surface.",
      oily:        "Toner balances pH, tightens pores, and prepares the skin to absorb actives — the key sebum-control step before your serum.",
      combination: "A balancing toner preps the entire face uniformly, helping both the oily T-zone and dry cheeks absorb the serum better.",
      sensitive:   "A fragrance-free, alcohol-free toner restores the skin's pH balance and soothes redness without any irritation."
    },
    3: {
      dry:         "The serum is where you tackle deep dehydration. Its concentrated actives penetrate into lower skin layers to resolve moisture loss at the source.",
      oily:        "A targeted serum controls sebum production, minimizes pores, and addresses breakouts more precisely than any moisturizer can.",
      combination: "A lightweight serum delivers concentrated actives where needed most, adapting to both oily and dry zones of the face.",
      sensitive:   "A soothing serum or ampoule repairs a compromised skin barrier from within and calms reactivity without irritating."
    },
    4: {
      dry:         "A rich moisturizer seals in all the hydration from previous steps and replenishes the lipids your skin barrier needs to stay healthy.",
      oily:        "Oily skin still needs hydration — without it, it produces more oil to compensate. A gel formula delivers water without any heaviness.",
      combination: "A lightweight but nourishing moisturizer is key for combination skin: it hydrates the cheeks without clogging the T-zone pores.",
      sensitive:   "A barrier-repairing moisturizer is the most important step for sensitive skin — it locks in calming actives and shields against daily irritants."
    },
    5: {
      dry:         "Sunscreen is the single most impactful anti-aging step. For dry skin, choose a formula that hydrates while it protects.",
      oily:        "A lightweight, water-type sunscreen absorbs instantly without leaving shine or stickiness on oily skin.",
      combination: "A water-fit sunscreen finishes light and fresh, without emphasizing the oily T-zone or drying out the cheeks.",
      sensitive:   "Mineral (physical) filters reflect UV rays off the skin surface without penetrating — the safest option for reactive or pregnant skin."
    }
  },
  ko: {
    1: {
      dry:         "건성 피부는 세안 시 피부 장벽이 손상되기 쉬워요. 약산성 저자극 클렌저로 수분을 지키면서 깨끗이 세정하는 것이 핵심입니다.",
      oily:        "지성 피부는 피지 과잉이 트러블의 시작이에요. 지성 전용 클렌저로 모공 속 노폐물을 깊이 세정하세요.",
      combination: "복합성 피부는 T존과 볼의 유수분 균형이 중요해요. 거품이 부드러운 약산성 클렌저를 선택하세요.",
      sensitive:   "민감한 피부는 설페이트·향료 없는 포뮬러가 핵심이에요. 자극 없이 세정하면서 피부 반응성을 낮춰줍니다."
    },
    2: {
      dry:         "토너는 세안 후 수분이 날아가기 전에 즉시 발라야 해요. 수분층을 빠르게 형성해 다음 세럼의 흡수력을 높여줍니다.",
      oily:        "토너는 pH를 조절하고 모공을 정돈해 피지 관리의 시작점이 돼요. 세럼 전에 필수로 사용하세요.",
      combination: "토너가 피부 전체를 균일하게 준비시켜줘요 — T존은 정돈하고 볼은 수분을 공급해 세럼 흡수를 높여줍니다.",
      sensitive:   "민감성 피부엔 향료·알코올 없는 순한 토너가 최우선이에요. 피부 pH를 맞추면서 붉은기도 진정시켜요."
    },
    3: {
      dry:         "세럼은 피부의 '속건조'를 해결하는 핵심 단계예요. 고농축 수분 성분이 피부 깊은 층까지 침투해 수분을 꽉 채워줍니다.",
      oily:        "지성 전용 세럼은 피지 분비를 뿌리부터 조절하고 모공을 정돈해줘요. 크림보다 훨씬 정밀하게 피부 문제를 해결합니다.",
      combination: "가벼운 세럼이 T존과 볼 어디든 필요한 곳에 성분을 정확히 전달해요.",
      sensitive:   "수딩 세럼은 자극받은 피부 장벽을 즉각 복구하고 예민한 피부를 안에서부터 진정시켜줘요."
    },
    4: {
      dry:         "크림은 앞 단계에서 쌓인 수분을 피부 속에 봉인하고, 지질 장벽을 복구해 다음날까지 촉촉함을 유지해줘요.",
      oily:        "지성 피부도 수분이 필요해요 — 없으면 피지를 더 만들어요. 젤 제형이 기름기 없이 수분만 채워줍니다.",
      combination: "가볍지만 충분히 보습되는 크림이 복합성 피부의 핵심이에요. T존은 번들거리지 않게, 볼은 촉촉하게 유지해줘요.",
      sensitive:   "보습 크림은 민감성 피부의 가장 중요한 단계예요 — 진정 성분을 봉인하고 외부 자극으로부터 피부를 보호해줍니다."
    },
    5: {
      dry:         "선크림은 피부 노화를 막는 가장 강력한 단계예요. 건성 피부엔 보습력도 함께 챙기는 제형을 선택하세요.",
      oily:        "에센스처럼 가볍게 발리는 수분형 선크림이 지성 피부에 최적이에요. 번들거림 없이 산뜻하게 마무리돼요.",
      combination: "워터핏 선크림은 가볍고 산뜻하게 마무리되어 T존이 번들거리지 않아요.",
      sensitive:   "민감·임산부 피부엔 무기자차(물리적 필터)가 가장 안전해요. 성분 자극 없이 자외선을 반사해요."
    }
  }
};

// 6(아이크림)/7(마스크)단계 why 텍스트 (step-6=아이크림, step-7=마스크 — Shopify 태그 기준)
Object.assign(stepWhyTexts.es, {
  6: { dry: "El contorno de ojos tiene 10x menos glándulas sebáceas que el resto del rostro. Es la primera zona donde aparecen arrugas — necesita hidratación específica.", oily: "Aunque tengas piel grasa, el contorno es muy delgado y necesita cuidado específico. Aplícalo mañana y noche con el dedo anular.", combination: "El contorno de ojos es independiente del tipo de piel — siempre necesita cuidados específicos para ojeras, bolsas y líneas de expresión.", sensitive: "El contorno es la zona más delicada del rostro. Elige fórmulas sin fragancia y sin retinol para piel sensible." },
  7: { dry: "Una mascarilla 1-2x semana aporta un extra de nutrición e hidratación que la rutina diaria no puede dar. Úsala tras el tónico.", oily: "Una mascarilla 1-2x semana resetea la piel y ayuda a reequilibrarla como tratamiento semanal.", combination: "Usada 1x semana, la mascarilla equilibra la piel mixta y realza su luminosidad.", sensitive: "Una mascarilla 1x semana calma la piel y refuerza la barrera cutánea." }
});
Object.assign(stepWhyTexts.en, {
  6: { dry: "The eye area has 10x fewer sebaceous glands than the rest of the face. It's the first zone to show wrinkles — it needs targeted hydration.", oily: "Even with oily skin, the eye contour is extremely thin and needs specific care. Apply morning and night with your ring finger.", combination: "Eye cream is independent of skin type — this area always needs targeted care for dark circles, puffiness, and expression lines.", sensitive: "The eye contour is the most delicate area. Choose fragrance-free, retinol-free formulas for sensitive skin." },
  7: { dry: "A mask 1-2x weekly delivers extra nourishment and hydration your daily routine can't provide. Use after toner.", oily: "A mask 1-2x weekly resets and rebalances the skin as a weekly treatment.", combination: "Used once a week, a mask balances combination skin and boosts radiance.", sensitive: "A mask once a week calms the skin and reinforces the barrier." }
});
Object.assign(stepWhyTexts.ko, {
  6: { dry: "눈가는 피부 두께가 0.5mm로 얼굴에서 가장 얇아요. 피지선이 거의 없어서 빨리 건조해지고 잔주름이 먼저 생겨요 — 전용 아이크림이 필수예요.", oily: "지성 피부여도 눈가는 얇고 건조해요. 약지 손가락으로 아침·저녁 가볍게 두드려 발라주세요.", combination: "아이크림은 피부 타입과 관계없이 필요해요 — 다크서클, 붓기, 잔주름에는 전용 케어가 필요해요.", sensitive: "눈가는 얼굴에서 가장 예민한 부위예요. 향료·레티놀 없는 순한 포뮬러를 선택하세요." },
  7: { dry: "주 1-2회 마스크팩은 데일리 루틴이 줄 수 없는 집중 영양·수분을 한 번에 채워줘요. 토너 후 사용하세요.", oily: "주 1-2회 마스크팩으로 피부 컨디션을 리셋하고 밸런스를 잡아줘요.", combination: "주 1회 마스크팩으로 피부 전체 밸런스를 맞추고 광채를 살려줘요.", sensitive: "주 1회 마스크팩으로 피부를 편안하게 진정시키고 장벽을 케어해줘요." }
});

// ⚠️ 단계 번호는 Shopify skinquiz:step-N 태그와 일치해야 함.
// step-6 = 아이크림, step-7 = 마스크 (Shopify 태그 기준). 각질 전용 단계는 없음(각질 앰플=step-2).
const STEP_TYPE_NAMES = {
  es: { 1:'Limpiador', 2:'Tónico', 3:'Sérum / Esencia', 4:'Crema Hidratante', 5:'Protector Solar', 6:'Contorno de Ojos', 7:'Mascarilla Facial' },
  en: { 1:'Cleanser', 2:'Toner', 3:'Serum / Essence', 4:'Moisturizer', 5:'Sunscreen', 6:'Eye Cream', 7:'Face Mask' },
  ko: { 1:'클렌저', 2:'토너', 3:'세럼/에센스', 4:'보습크림', 5:'자외선차단제', 6:'아이크림', 7:'마스크팩' }
};

// ── 고민별 "이 제품이 맞는 이유" 1문장 ───────────────────────────────────────
const CONCERN_REASONS = {
  es: {
    dryness:  'Fórmula especialmente hidratante para tu piel seca y sin agua.',
    acne:     'Ingredientes que controlan el sebo y reducen los brotes de acné.',
    redness:  'Activos calmantes y antiinflamatorios que reducen la rojez.',
    dullness: 'Ingredientes iluminadores para un tono de piel más uniforme y radiante.',
    poros:    'Minimiza la apariencia de poros y regula el exceso de sebo.',
    firmeza:  'Estimula la producción de colágeno para mejorar firmeza y elasticidad.',
    ojeras:   'Hidrata y aclara el contorno de ojos para reducir ojeras y fatiga.'
  },
  en: {
    dryness:  'Especially hydrating formula for your dry, dehydrated skin.',
    acne:     'Ingredients that control sebum and reduce acne breakouts.',
    redness:  'Calming, anti-inflammatory actives that reduce redness.',
    dullness: 'Brightening ingredients for a more even, radiant skin tone.',
    poros:    'Minimizes pore appearance and regulates excess sebum.',
    firmeza:  'Stimulates collagen production to improve firmness and elasticity.',
    ojeras:   'Hydrates and brightens the eye area to reduce dark circles and fatigue.'
  },
  ko: {
    dryness:  '건조하고 수분이 부족한 피부를 위한 집중 보습 포뮬러입니다.',
    acne:     '피지를 조절하고 여드름 발생을 억제하는 성분이 함유되어 있습니다.',
    redness:  '염증을 줄이고 민감한 피부를 진정시키는 성분이 들어 있습니다.',
    dullness: '피부 톤을 균일하게 하고 광채를 더하는 미백 성분이 함유되어 있습니다.',
    poros:    '모공의 가시성을 줄이고 과도한 피지를 조절합니다.',
    firmeza:  '콜라겐 생성을 자극하여 탄력과 피부 탄탄함을 개선합니다.',
    ojeras:   '눈가를 촉촉하게 하고 다크서클과 피로감을 완화합니다.'
  }
};

const SKIN_TYPE_COLORS = {
  dry:         { main: '#E8845A', light: '#FDF0EA', border: '#F5C4A8', text: '#C05A2A' },
  oily:        { main: '#4DB89E', light: '#EAF7F4', border: '#A8E0D5', text: '#2A7A68' },
  combination: { main: '#9B72CF', light: '#F3EEFB', border: '#D4BBEF', text: '#6840A8' },
  sensitive:   { main: '#E07B8F', light: '#FDECEF', border: '#F5B8C4', text: '#B8455A' }
};

const CONCERN_NAMES = {
  es: { dryness:'Sequedad', acne:'Acné', redness:'Rojez', dullness:'Luminosidad', poros:'Poros', firmeza:'Firmeza', ojeras:'Ojeras' },
  en: { dryness:'Dryness', acne:'Acne', redness:'Redness', dullness:'Dullness', poros:'Pores', firmeza:'Firmness', ojeras:'Dark Circles' },
  ko: { dryness:'건조함', acne:'트러블', redness:'홍조', dullness:'칙칙함', poros:'모공', firmeza:'탄력', ojeras:'다크서클' }
};

const CONCERN_EMOJIS = {
  dryness:'🏜️', acne:'🔴', redness:'🌹', dullness:'🌙', poros:'🔬', firmeza:'⚡', ojeras:'🌑'
};

const AGE_NAMES = {
  es: { teen:'10s', twenties:'20s', thirties:'30s', forties:'40s+' },
  en: { teen:'10s', twenties:'20s', thirties:'30s', forties:'40s+' },
  ko: { teen:'10대', twenties:'20대', thirties:'30대', forties:'40대+' }
};

const CONCERN_TIMELINES = {
  es: {
    dryness:  'La hidratación superficial se nota al instante, pero reparar la barrera lipídica para que la piel retenga agua por sí misma requiere 4-6 semanas con ceramidas.',
    acne:     'La reducción de brotes activos empieza en 2-4 semanas. Para reducir cicatrices e hiperpigmentación post-acné, necesitas 8-12 semanas de constancia.',
    redness:  'La centella asiática reduce la rojez visible en 2-3 semanas. La reparación completa de la barrera (y menos reactividad) tarda 6-8 semanas.',
    dullness: 'La vitamina C y la exfoliación suave dan resultados rápidos: la piel se ve más luminosa en 1-2 semanas. La mejora profunda del tono lleva 6-8 semanas.',
    poros:    'Los poros no desaparecen, pero se minimizan. Con niacinamida y ácido salicílico, notarás menos brillo y poros más limpios en 3-4 semanas.',
    firmeza:  'Los péptidos y el retinol muestran primeros resultados en 4-6 semanas, pero la mejora estructural real del colágeno requiere 3-6 meses.',
    ojeras:   'La cafeína descongestiona en días. Para aclarar la pigmentación de ojeras (la causa más profunda) necesitas 6-8 semanas de constancia.'
  },
  en: {
    dryness:  'Surface hydration is noticeable immediately, but repairing the lipid barrier so skin retains water on its own requires 4-6 weeks with ceramides.',
    acne:     'Reduction of active breakouts begins in 2-4 weeks. To reduce post-acne scars and hyperpigmentation, you need 8-12 weeks of consistency.',
    redness:  'Centella asiatica reduces visible redness in 2-3 weeks. Complete barrier repair (and less reactivity) takes 6-8 weeks.',
    dullness: 'Vitamin C and gentle exfoliation give quick results: skin looks more radiant in 1-2 weeks. Deep tone improvement takes 6-8 weeks.',
    poros:    'Pores don\'t disappear, but they minimize. With niacinamide and salicylic acid, you\'ll notice less shine and cleaner pores in 3-4 weeks.',
    firmeza:  'Peptides and retinol show first results in 4-6 weeks, but real structural collagen improvement requires 3-6 months.',
    ojeras:   'Caffeine decongests in days. To lighten dark circle pigmentation (the deeper cause) you need 6-8 weeks of consistency.'
  },
  ko: {
    dryness:  '즉각적인 표면 수분 공급은 바로 느껴지지만, 피부가 스스로 수분을 유지할 수 있도록 지질 장벽을 복구하려면 세라마이드로 4-6주가 필요합니다.',
    acne:     '활성 트러블 감소는 2-4주 안에 시작됩니다. 여드름 후 흉터와 색소 침착을 줄이려면 8-12주의 꾸준한 관리가 필요합니다.',
    redness:  '병풀은 2-3주 안에 홍조를 눈에 띄게 줄입니다. 장벽 완전 복구(반응성 감소)는 6-8주가 걸립니다.',
    dullness: '비타민C와 순한 각질 제거는 빠른 결과를 줍니다: 1-2주 안에 피부가 더 환하게 보입니다. 깊은 톤 개선은 6-8주가 필요합니다.',
    poros:    '모공은 없어지지 않지만 최소화됩니다. 나이아신아마이드와 살리실산으로 3-4주 안에 덜 번들거리고 더 깨끗한 모공을 느낄 수 있습니다.',
    firmeza:  '펩타이드와 레티놀은 4-6주 안에 첫 결과를 보여주지만, 실질적인 콜라겐 구조 개선에는 3-6개월이 필요합니다.',
    ojeras:   '카페인은 며칠 안에 충혈을 줄입니다. 다크서클 색소 침착(더 깊은 원인) 개선에는 6-8주의 꾸준한 관리가 필요합니다.'
  }
};

const SKIN_TYPE_PROFILES = {
  dry: {
    emoji: '🏜️',
    characteristics: {
      es: ['Tirantez constante', 'Zonas descamadas', 'Poros pequeños', 'Líneas finas prematuras'],
      en: ['Constant tightness', 'Flaky areas', 'Small pores', 'Premature fine lines'],
      ko: ['지속적인 당김', '각질 일어남', '작은 모공', '조기 잔주름']
    },
    why: {
      es: 'La barrera lipídica de tu piel es más fina de lo normal, lo que hace que el agua se evapore rápidamente (pérdida transepidérmica). Por eso la piel se siente tirante y áspera, especialmente después de lavarla o con el frío.',
      en: 'Your skin\'s lipid barrier is thinner than normal, causing water to evaporate quickly (transepidermal water loss). That\'s why skin feels tight and rough, especially after washing or in cold weather.',
      ko: '피부의 지질 장벽이 정상보다 얇아 수분이 빠르게 증발합니다(경피 수분 손실). 그래서 세안 후나 추운 날씨에 피부가 당기고 거칩니다.'
    },
    needs: {
      es: 'Tu piel necesita dos cosas: hidratación (agua, ácido hialurónico) y nutrición (aceites, ceramidas) que sellen esa hidratación. La técnica de capas del K-Beauty es perfecta para ti: varias capas de productos ligeros penetran mejor que una sola capa de crema densa.',
      en: 'Your skin needs two things: hydration (water, hyaluronic acid) and nourishment (oils, ceramides) to seal in that moisture. K-Beauty layering is perfect for you: multiple light layers penetrate better than one thick cream.',
      ko: '피부에 두 가지가 필요합니다: 수분(물, 히알루론산)과 그 수분을 잠가줄 영양(오일, 세라마이드). K-Beauty 레이어링 기법이 딱 맞습니다: 여러 겹의 가벼운 제품이 한 번의 짙은 크림보다 더 잘 침투합니다.'
    }
  },
  oily: {
    emoji: '💧',
    characteristics: {
      es: ['Brillo excesivo durante el día', 'Poros dilatados visibles', 'Acné o granos frecuentes', 'Maquillaje no dura'],
      en: ['Excessive shine during the day', 'Visible enlarged pores', 'Frequent acne or breakouts', 'Makeup doesn\'t last'],
      ko: ['낮에 과도한 피지', '눈에 보이는 확장된 모공', '잦은 트러블', '메이크업이 오래 지속되지 않음']
    },
    why: {
      es: 'Tus glándulas sebáceas producen más sebo del necesario, lo que obstruye los poros y crea el ambiente ideal para la bacteria del acné (C. acnes). Esto no es falta de higiene — es genético y hormonal.',
      en: 'Your sebaceous glands produce more oil than needed, clogging pores and creating the ideal environment for acne bacteria (C. acnes). This is not a hygiene issue — it\'s genetic and hormonal.',
      ko: '피지선이 필요 이상으로 피지를 생산해 모공을 막고 여드름균(C. acnes)이 자라기 좋은 환경을 만듭니다. 이는 위생 문제가 아니라 유전적·호르몬적인 특성입니다.'
    },
    needs: {
      es: 'Contra-intuitivo pero clave: la piel grasa también necesita hidratación. Sin ella, produce más sebo para compensar. Necesitas limpieza suave (sin sulfatos agresivos), hidratación ligera tipo gel, y activos reguladores como niacinamida y ácido salicílico.',
      en: 'Counter-intuitive but key: oily skin needs hydration too. Without it, it produces more sebum to compensate. You need gentle cleansing, lightweight gel-type hydration, and regulating actives like niacinamide and salicylic acid.',
      ko: '반직관적이지만 중요: 지성 피부도 수분이 필요합니다. 수분이 없으면 피지를 더 많이 생산합니다. 순한 세안, 가벼운 젤 타입 수분, 나이아신아마이드와 살리실산 같은 조절 성분이 필요합니다.'
    }
  },
  combination: {
    emoji: '⚖️',
    characteristics: {
      es: ['Zona T brillante (frente, nariz, barbilla)', 'Mejillas secas o normales', 'Poros visibles en nariz', 'Reacciona diferente según la zona'],
      en: ['Shiny T-zone (forehead, nose, chin)', 'Dry or normal cheeks', 'Visible pores on nose', 'Reacts differently by zone'],
      ko: ['T존 광택(이마, 코, 턱)', '볼 부분은 건조하거나 정상', '코 모공 가시성', '부위별로 다른 반응']
    },
    why: {
      es: 'La densidad de glándulas sebáceas no es uniforme en tu cara — la zona T tiene hasta 4-5 veces más glándulas que las mejillas. Esto crea dos microclimas en una misma piel que necesitan atención diferente.',
      en: 'Sebaceous gland density is not uniform across your face — the T-zone has up to 4-5 times more glands than the cheeks. This creates two microclimates on the same skin that need different care.',
      ko: '피지선 밀도가 얼굴 전체에 고르지 않습니다 — T존에는 볼보다 4-5배 많은 피지선이 있어 같은 피부에 두 가지 마이크로 기후를 만들어 각기 다른 케어가 필요합니다.'
    },
    needs: {
      es: 'Tu piel necesita equilibrio, no extremos. Un hidratante ligero que no tape los poros pero que nutra las mejillas. El tónico es clave: prepara la piel uniformemente. La niacinamida es tu mejor aliada — equilibra sin secar.',
      en: 'Your skin needs balance, not extremes. A lightweight moisturizer that doesn\'t clog pores but nourishes cheeks. The toner is key: it preps skin evenly. Niacinamide is your best ally — balances without drying.',
      ko: '피부에는 극단이 아닌 균형이 필요합니다. 모공을 막지 않으면서 볼을 영양 공급하는 가벼운 보습제. 토너가 루틴의 핵심: 세럼 적용 전 피부를 균일하게 준비합니다. 나이아신아마이드가 최고의 동반자입니다.'
    }
  },
  sensitive: {
    emoji: '🌸',
    characteristics: {
      es: ['Rojez frecuente o constante', 'Reacciona a nuevos productos', 'Sensación de picor o ardor', 'Barrera cutánea debilitada'],
      en: ['Frequent or constant redness', 'Reacts to new products', 'Itching or burning sensation', 'Weakened skin barrier'],
      ko: ['잦거나 지속적인 홍조', '새 제품에 반응', '가려움 또는 따가움', '약화된 피부 장벽']
    },
    why: {
      es: 'Tu barrera cutánea (capa córnea) tiene brechas que permiten que irritantes externos penetren más fácilmente y que el agua escape. Esto activa el sistema inmune de la piel generando inflamación visible como rojez.',
      en: 'Your skin barrier (stratum corneum) has gaps that allow external irritants to penetrate more easily and water to escape. This activates the skin\'s immune system, generating visible inflammation like redness.',
      ko: '피부 장벽(각질층)에 틈이 있어 외부 자극물이 더 쉽게 침투하고 수분이 빠져나갑니다. 이로 인해 피부 면역 시스템이 활성화되어 홍조 같은 가시적인 염증이 생깁니다.'
    },
    needs: {
      es: 'Menos es más. Tu piel necesita reparar la barrera con ingredientes calmantes (centella asiática, pantenol) y evitar irritantes comunes: fragancias, alcoholes, exfoliantes agresivos. Introduce nuevos productos de uno en uno, con paciencia.',
      en: 'Less is more. Your skin needs to repair the barrier with calming ingredients (centella asiatica, panthenol) and avoid common irritants: fragrances, alcohols, harsh exfoliants. Introduce new products one at a time, with patience.',
      ko: '적을수록 좋습니다. 피부는 진정 성분(병풀, 판테놀)으로 장벽을 복구하고 향료, 알코올, 강한 각질 제거제를 피해야 합니다. 새 제품은 하나씩 천천히 도입하세요.'
    }
  }
};

const SKIN_TYPE_KEY_INGREDIENTS = {
  dry: [
    { emoji:'💧', name:{es:'Ácido Hialurónico',en:'Hyaluronic Acid',ko:'히알루론산'}, desc:{es:'Retiene 1000x su peso en agua. Hidratación profunda.',en:'Retains 1000x its weight in water. Deep hydration.',ko:'자기 무게의 1000배 수분 보유. 깊은 수분 공급.'} },
    { emoji:'🧱', name:{es:'Ceramidas',en:'Ceramides',ko:'세라마이드'}, desc:{es:'Reparan la barrera cutánea evitando pérdida de agua.',en:'Repair the skin barrier preventing water loss.',ko:'피부 장벽을 복구해 수분 손실을 방지합니다.'} },
    { emoji:'🩹', name:{es:'Pantenol (Vit. B5)',en:'Panthenol (Vit. B5)',ko:'판테놀(비타민B5)'}, desc:{es:'Vitamina B5: calma, hidrata y repara la barrera.',en:'Vitamin B5: calms, hydrates and repairs the barrier.',ko:'비타민B5: 진정, 보습, 피부 장벽 복구.'} }
  ],
  oily: [
    { emoji:'✨', name:{es:'Niacinamida',en:'Niacinamide',ko:'나이아신아마이드'}, desc:{es:'Regula el sebo, afina los poros y unifica el tono.',en:'Regulates sebum, minimizes pores and evens tone.',ko:'피지 조절, 모공 축소, 피부 톤 균일화.'} },
    { emoji:'🔬', name:{es:'Ácido Salicílico (BHA)',en:'Salicylic Acid (BHA)',ko:'살리실산(BHA)'}, desc:{es:'Exfolia dentro del poro y elimina el sebo atrapado.',en:'Exfoliates inside the pore and removes trapped sebum.',ko:'모공 내부를 각질 제거하고 피지를 제거합니다.'} },
    { emoji:'🌿', name:{es:'Centella Asiática',en:'Centella Asiatica',ko:'병풀 추출물'}, desc:{es:'Calma la inflamación y cicatriza las marcas de acné.',en:'Calms inflammation and heals acne marks.',ko:'염증을 진정시키고 여드름 자국을 치유합니다.'} }
  ],
  combination: [
    { emoji:'⚖️', name:{es:'Niacinamida',en:'Niacinamide',ko:'나이아신아마이드'}, desc:{es:'Equilibra la Zona T sin resecar las mejillas.',en:'Balances T-zone without drying the cheeks.',ko:'볼을 건조하게 하지 않고 T존 균형을 맞춥니다.'} },
    { emoji:'💧', name:{es:'Ácido Hialurónico',en:'Hyaluronic Acid',ko:'히알루론산'}, desc:{es:'Hidratación ligera que se adapta a cada zona.',en:'Lightweight hydration that adapts to each zone.',ko:'각 부위에 맞는 가벼운 수분 공급.'} },
    { emoji:'🍶', name:{es:'Galactomyces Ferment',en:'Galactomyces Ferment',ko:'갈락토마이세스'}, desc:{es:'Ilumina y regula la producción de sebo.',en:'Brightens and regulates sebum production.',ko:'피부 광채 & 피지 조절.'} }
  ],
  sensitive: [
    { emoji:'🌱', name:{es:'Centella Asiática',en:'Centella Asiatica',ko:'병풀 추출물'}, desc:{es:'El calmante más potente para pieles reactivas.',en:'Nature\'s most potent calming agent for reactive skin.',ko:'반응성 피부를 위한 가장 강력한 진정 성분.'} },
    { emoji:'🩹', name:{es:'Pantenol (Vit. B5)',en:'Panthenol (Vit. B5)',ko:'판테놀(비타민B5)'}, desc:{es:'Regenera la barrera y calma el picor e irritación.',en:'Regenerates the barrier and calms itching & irritation.',ko:'장벽을 재생하고 가려움 & 자극을 진정시킵니다.'} },
    { emoji:'🛡️', name:{es:'Beta-Glucano',en:'Beta-Glucan',ko:'베타글루칸'}, desc:{es:'Protege la barrera y calma la piel al instante.',en:'Protects the barrier and instantly calms the skin.',ko:'장벽 보호 & 즉각 피부 진정.'} }
  ]
};

// ==================== 9b. 티어 토글(필수/추천/전체) + 총액 표시 ====================
// 초심자 진입장벽 완화용. 기본값 'completo'는 기존 동작과 동일(전체 표시, 회귀 없음).
const TIER_LABELS = {
  es: { esencial: 'Esencial', recomendado: 'Recomendado', completo: 'Completo', total: 'Total del kit' },
  en: { esencial: 'Essential', recomendado: 'Recommended', completo: 'Full', total: 'Kit total' },
  ko: { esencial: '필수만', recomendado: '추천', completo: '전체', total: '총 금액' }
};
function _tierLabels() { return TIER_LABELS[currentLang] || TIER_LABELS.es; }

function _renderTierToggle() {
  const t = _tierLabels();
  const btn = (key) => `<button class="tier-btn ${selectedTier === key ? 'active' : ''}" data-tier="${key}" onclick="switchTier('${key}')">${t[key]}</button>`;
  return `
    <div class="tier-toggle-row">
      <div class="tier-toggle" id="tier-toggle">
        ${btn('esencial')}${btn('recomendado')}${btn('completo')}
      </div>
    </div>`;
}

// 루틴 카드 목록 맨 아래에 위치하는 총액 요약 바(필터링과 분리 — "다 보고 난 뒤 합계"가 되도록)
function _renderRoutineTotalBar() {
  const t = _tierLabels();
  return `
    <div class="routine-total-bar">
      <span class="routine-total-label">${t.total}</span>
      <strong class="routine-total-price" id="routine-total-price">0.00€</strong>
    </div>`;
}

function switchTier(tier) {
  selectedTier = tier;
  _applyTierFilter();
}

// 이미 렌더된 카드를 숨기고/보이며 재조회 없이 티어 필터링 + 총액 재계산
function _applyTierFilter() {
  const order = { esencial: 1, recomendado: 2, completo: 3 };
  const threshold = order[selectedTier] || 3;
  let total = 0;
  document.querySelectorAll('#routine-products-list .product-card').forEach(card => {
    const cardOrder = order[card.dataset.tier] || 2;
    const visible = cardOrder <= threshold;
    card.style.display = visible ? '' : 'none';
    if (visible) total += parseFloat(card.dataset.price) || 0;
  });
  // 보완 제품 구분선: 전체 티어에서만 표시(전부 completo이므로)
  document.querySelectorAll('#routine-products-list .complementos-divider').forEach(div => {
    div.style.display = threshold >= 3 ? '' : 'none';
  });
  const totalEl = document.getElementById('routine-total-price');
  if (totalEl) totalEl.textContent = total.toFixed(2) + '€';
  document.querySelectorAll('#tier-toggle .tier-btn').forEach(b => {
    b.classList.toggle('active', b.dataset.tier === selectedTier);
  });
}

// ==================== 10. 결과 화면 자연스러운 조사 및 문장 렌더링 ====================
function switchRoutineTab(tab) {
  selectedRoutineTab = tab;
  document.getElementById('tab-dia').classList.remove('active');
  document.getElementById('tab-noche').classList.remove('active');
  
  if (tab === 'dia') {
    document.getElementById('tab-dia').classList.add('active');
  } else {
    document.getElementById('tab-noche').classList.add('active');
  }
  
  renderRoutineTimeline();
}

// ── 결과 페이지 리포트 렌더링 헬퍼 ──────────────────────────────────────────
function _getRSkinColors() {
  return SKIN_TYPE_COLORS[detectedSkinType] || SKIN_TYPE_COLORS.combination;
}

function _renderReportHero() {
  const c = _getRSkinColors();
  const skinKey = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
  const profile = SKIN_TYPE_PROFILES[detectedSkinType] || {};
  const typeName = i18n[currentLang][`skin_${skinKey}`] || detectedSkinType;
  const concernArr = Array.isArray(answers['q5_concern']) ? answers['q5_concern'] : (answers['q5_concern'] ? [answers['q5_concern']] : []);
  const concernNames = concernArr.map(c2 => CONCERN_NAMES[currentLang]?.[c2] || c2).join(' + ');
  const ageName = AGE_NAMES[currentLang]?.[userAge] || '';
  const summary = [typeName, ageName, concernNames].filter(Boolean).join(' | ');
  const profileLabel = currentLang === 'ko' ? '나의 피부 유형' : (currentLang === 'en' ? 'YOUR SKIN TYPE' : 'TU PERFIL DE PIEL');
  const charList = (profile.characteristics?.[currentLang] || [])
    .map(ch => `<div class="skin-char-item"><span class="skin-char-heart" style="color:${c.main}">♥</span><span>${ch}</span></div>`)
    .join('');
  const descKey = `desc_${skinKey}`;
  const descText = i18n[currentLang][descKey] || '';
  return `
    <div class="report-hero" style="background:${c.main};">
      <div class="report-hero-emoji">${profile.emoji || '✨'}</div>
      <p class="report-hero-label">${profileLabel}</p>
      <h2 class="report-hero-title">${typeName}</h2>
      <p class="report-hero-summary">${summary}</p>
    </div>
    <div class="report-desc-block" style="background:${c.light}; border-color:${c.border};">
      <p class="report-desc-text">${descText}</p>
      <div class="skin-chars-list">${charList}</div>
    </div>`;
}

function _renderReportWhyNeeds() {
  const c = _getRSkinColors();
  const profile = SKIN_TYPE_PROFILES[detectedSkinType];
  if (!profile) return '';
  const why = profile.why?.[currentLang] || '';
  const needs = profile.needs?.[currentLang] || '';
  const whyLabel = currentLang === 'ko' ? '🔬 왜 이렇게 행동하나요?' : (currentLang === 'en' ? '🔬 Why does your skin behave this way?' : '🔬 ¿Por qué tu piel se comporta así?');
  const needsLabel = currentLang === 'ko' ? '🎯 피부에 필요한 것은?' : (currentLang === 'en' ? '🎯 What does your skin need?' : '🎯 ¿Qué necesita tu piel?');
  return `
    <div class="report-edu-section">
      <h4 class="report-edu-title" style="color:${c.text};">${whyLabel}</h4>
      <p class="report-edu-text">${why}</p>
      <h4 class="report-edu-title" style="color:${c.text}; margin-top:16px;">${needsLabel}</h4>
      <p class="report-edu-text">${needs}</p>
    </div>`;
}

function _renderReportConcernAnalysis() {
  const c = _getRSkinColors();
  const concernArr = Array.isArray(answers['q5_concern']) ? answers['q5_concern'] : (answers['q5_concern'] ? [answers['q5_concern']] : []);
  if (!concernArr.length) return '';
  const header = currentLang === 'ko' ? '🎯 고민 분석' : (currentLang === 'en' ? '🎯 Concern Analysis' : '🎯 Análisis de tus preocupaciones');
  const prioLabels = [
    currentLang === 'ko' ? '1순위' : (currentLang === 'en' ? '1st Priority' : '1ª PRIORIDAD'),
    currentLang === 'ko' ? '2순위' : (currentLang === 'en' ? '2nd Priority' : '2ª PRIORIDAD')
  ];
  const blocks = concernArr.map((concern, idx) => {
    const name = CONCERN_NAMES[currentLang]?.[concern] || concern;
    const emoji = CONCERN_EMOJIS[concern] || '✦';
    const reason = CONCERN_REASONS[currentLang]?.[concern] || '';
    const timeline = CONCERN_TIMELINES[currentLang]?.[concern] || '';
    return `
      <div class="report-concern-block" style="background:${c.light}; border-color:${c.border};">
        <span class="report-concern-priority" style="background:${c.main};">${prioLabels[idx] || ''}</span>
        <h4 class="report-concern-title">${emoji} ${name}</h4>
        <p class="report-concern-desc">${reason}</p>
        ${timeline ? `<p class="report-concern-timeline" style="color:${c.text};">${timeline}</p>` : ''}
      </div>`;
  }).join('');
  return `
    <div class="report-edu-section">
      <h3 class="report-section-header">${header}</h3>
      ${blocks}
    </div>`;
}

// 고민별 핵심 성분 — `tag`는 실제 제품 ingredientsTags와 일치(루틴이 이 성분 든 제품을 우선 추천).
// 표시(핵심성분 카드)와 루틴 추천이 같은 기준을 쓰도록 단일 소스로 사용한다.
const CONCERN_KEY_INGREDIENTS = {
  dryness:  { tag:'hyaluronic', emoji:'💧', name:{es:'Ácido Hialurónico',en:'Hyaluronic Acid',ko:'히알루론산'},
              desc:{es:'Hidratación profunda que retiene el agua en la piel.',en:'Deep hydration that locks water into the skin.',ko:'속까지 수분을 채우고 잡아주는 고보습 성분.'} },
  acne:     { tag:'teatree', emoji:'🍵', name:{es:'Árbol de Té (Tea Tree)',en:'Tea Tree',ko:'티트리'},
              desc:{es:'Controla el sebo y calma los brotes de acné.',en:'Controls sebum and calms acne breakouts.',ko:'피지를 조절하고 반복 트러블을 진정시켜요.'} },
  redness:  { tag:'centella', emoji:'🌿', name:{es:'Centella Asiática',en:'Centella Asiatica',ko:'병풀(센텔라)'},
              desc:{es:'Calma la rojez y repara la barrera sensible.',en:'Calms redness and repairs the sensitive barrier.',ko:'홍조를 진정시키고 예민한 장벽을 회복시켜요.'} },
  dullness: { tag:'niacinamide', emoji:'✨', name:{es:'Niacinamida',en:'Niacinamide',ko:'나이아신아마이드'},
              desc:{es:'Ilumina y unifica el tono apagado.',en:'Brightens and evens out a dull tone.',ko:'칙칙한 피부 톤을 환하고 균일하게 밝혀줘요.'} },
  poros:    { tag:'propolis', emoji:'🐝', name:{es:'Propóleo',en:'Propolis',ko:'프로폴리스'},
              desc:{es:'Cuida y refina los poros regulando el exceso de sebo.',en:'Cares for and refines pores by regulating sebum.',ko:'피지를 정돈하며 모공을 케어해줘요.'} },
  firmeza:  { tag:'ginseng', emoji:'🌱', name:{es:'Ginseng',en:'Ginseng',ko:'인삼 추출물'},
              desc:{es:'Antioxidante que aporta firmeza y nutrición a la piel madura.',en:'Antioxidant that firms and nourishes mature skin.',ko:'항산화로 탄력과 영양을 더해주는 성숙 피부 케어.'} },
  ojeras:   { tag:'niacinamide', emoji:'🌙', name:{es:'Niacinamida',en:'Niacinamide',ko:'나이아신아마이드'},
              desc:{es:'Aclara el contorno y reduce la apariencia de ojeras.',en:'Brightens the eye area and reduces dark circles.',ko:'눈가를 밝혀 다크서클을 완화해줘요.'} }
};

function _renderReportKeyIngredients() {
  const c = _getRSkinColors();
  const concernArr = Array.isArray(answers['q5_concern']) ? answers['q5_concern'] : (answers['q5_concern'] ? [answers['q5_concern']] : []);
  const forWord = (label) => currentLang === 'ko' ? `${label} 맞춤` : (currentLang === 'en' ? `For ${label}` : `Para ${label}`);
  const items = [];
  const seen = new Set();
  const addIng = (ing, matchLabel) => {
    if (!ing) return;
    const key = (ing.name.en || ing.name.es).toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    items.push({ ing, matchLabel });
  };

  // 1) 고민별 성분 (1순위·2순위 각 1개)
  concernArr.slice(0, 2).forEach(cn => addIng(CONCERN_KEY_INGREDIENTS[cn], forWord(CONCERN_NAMES[currentLang]?.[cn] || cn)));

  // 2) 피부타입 대표 성분으로 3개까지 채움
  const skinKey = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
  const typeName = i18n[currentLang][`skin_${skinKey}`] || detectedSkinType;
  for (const ing of (SKIN_TYPE_KEY_INGREDIENTS[detectedSkinType] || [])) {
    if (items.length >= 3) break;
    addIng(ing, forWord(typeName));
  }
  if (!items.length) return '';

  const header = currentLang === 'ko' ? '🌿 핵심 성분' : (currentLang === 'en' ? '🌿 Your Key Ingredients' : '🌿 Tus ingredientes clave');
  const cards = items.map(({ ing, matchLabel }) => `
    <div class="report-ing-card" style="background:${c.light}; border-color:${c.border};">
      <div class="report-ing-header">
        <span class="report-ing-emoji">${ing.emoji}</span>
        <span class="report-ing-name" style="color:${c.text};">${ing.name[currentLang] || ing.name.es}</span>
      </div>
      <p class="report-ing-desc">${ing.desc[currentLang] || ing.desc.es}</p>
      <span style="display:inline-block;margin-top:8px;font-size:10.5px;font-weight:700;letter-spacing:.2px;color:${c.text};background:#fff;border:1px solid ${c.border};border-radius:20px;padding:2px 9px;">${matchLabel}</span>
    </div>`).join('');
  return `
    <div class="report-edu-section">
      <h3 class="report-section-header">${header}</h3>
      ${cards}
    </div>`;
}

function renderResult() {
  const resultView = document.getElementById('result-view');
  if (!resultView) return;

  // Apply skin-type color CSS variables
  const c = _getRSkinColors();
  document.documentElement.style.setProperty('--color-skin-main',   c.main);
  document.documentElement.style.setProperty('--color-skin-light',  c.light);
  document.documentElement.style.setProperty('--color-skin-border', c.border);
  document.documentElement.style.setProperty('--color-skin-text',   c.text);

  const routineHeader = currentLang === 'ko' ? '🧴 맞춤 K-Beauty 루틴' : (currentLang === 'en' ? '🧴 Your personalized K-Beauty routine' : '🧴 Tu rutina K-Beauty personalizada');
  const amLabel = currentLang === 'ko' ? '☀️ 아침 (AM)' : (currentLang === 'en' ? '☀️ Morning (AM)' : '☀️ Mañana (AM)');
  const pmLabel = currentLang === 'ko' ? '🌙 저녁 (PM)' : (currentLang === 'en' ? '🌙 Night (PM)' : '🌙 Noche (PM)');

  resultView.innerHTML = `
    ${_renderReportHero()}
    ${_renderReportWhyNeeds()}
    ${_renderReportConcernAnalysis()}
    ${_renderReportKeyIngredients()}

    <div class="report-routine-header">
      <h3 class="report-section-header">${routineHeader}</h3>
    </div>

    <div class="routine-tabs">
      <button class="tab-btn ${selectedRoutineTab === 'dia' ? 'active' : ''}" id="tab-dia" onclick="switchRoutineTab('dia')"><span>${amLabel}</span></button>
      <button class="tab-btn ${selectedRoutineTab === 'noche' ? 'active' : ''}" id="tab-noche" onclick="switchRoutineTab('noche')"><span>${pmLabel}</span></button>
    </div>

    ${_renderTierToggle()}

    <div class="water-only-card" id="water-only-card" style="display:none;">
      <span class="water-icon">💧</span>
      <div class="water-text">
        <h4>${i18n[currentLang]['water_title']}</h4>
        <p>${i18n[currentLang]['water_desc']}</p>
      </div>
    </div>

    <div class="routine-timeline" id="routine-products-list"></div>

    ${_renderRoutineTotalBar()}

    <div class="email-result-cta" id="email-result-cta">
      <p class="email-cta-label">${i18n[currentLang]['email_cta_label']}</p>
      <div class="email-cta-row">
        <input type="email" id="email-cta-input" class="email-cta-input" placeholder="${i18n[currentLang]['email_cta_placeholder']}" autocomplete="email" inputmode="email" onkeydown="if(event.key==='Enter'){event.preventDefault();subscribeEmail();}">
        <button type="button" class="btn-email-send" id="btn-email-send" onclick="subscribeEmail()">${i18n[currentLang]['email_cta_btn']}</button>
      </div>
      <label class="email-cta-consent" for="email-cta-consent">
        <input type="checkbox" id="email-cta-consent">
        <span>${i18n[currentLang]['email_cta_consent']}</span>
      </label>
      <p class="email-cta-privacy">🔒 ${i18n[currentLang]['email_cta_privacy']} <a href="${PRIVACY_URL}" target="_blank" rel="noopener" class="email-cta-privacy-link">${i18n[currentLang]['email_cta_privacy_link']}</a>.</p>
    </div>

    <div class="result-footer-help">
      <h3 class="help-title">${i18n[currentLang]['help_title']}</h3>
      <p class="help-desc">${i18n[currentLang]['help_desc']}</p>
      <button class="btn-save-image" onclick="downloadResultImage()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        ${i18n[currentLang]['save_image']}
      </button>
      <button class="btn-share" onclick="copyResultLink()">${i18n[currentLang]['help_btn']}</button>
    </div>

    <div class="secret-trigger">${i18n[currentLang]['secret_text']}</div>
  `;

  renderRoutineTimeline();
  // 낮/밤 양쪽 로드 후: 완주 통계 시트 전송(AM+PM 전체) + 이미지 저장용 사전 로드
  _prefetchBothTabs().then(() => {
    if (_pendingSheetData && !_pendingSheetSent) {
      _pendingSheetSent = true;
      _pendingSheetData.recommendedProducts = _buildRoutineText().replace(/\n/g, ' | ');
      sendToGoogleSheets(_pendingSheetData);
    }
  });
}

function _getStepPrescription(stepNum) {
  // ingredientPrescriptions는 1~5단계만 정의됨. 6+(아이크림·마스크·트리트먼트 등 보완단계)는
  // 성분 태그 사전이 없으므로 tag 없이 반환(호출부가 matches.length===0 폴백으로 전체 후보 사용).
  if (!ingredientPrescriptions[stepNum]) return null;
  let presc = ingredientPrescriptions[stepNum][detectedSkinType];
  const q5Raw = answers['q5_concern'];
  const currentConcern = Array.isArray(q5Raw) ? q5Raw[0] : q5Raw;

  if (userAge === 'forties') {
    if (stepNum === 3) presc = { tag: "ginseng", name: { es: "Ginseng Antioxidante", en: "Antioxidant Ginseng", ko: "고영양 항산화 인삼 추출물" } };
    if (stepNum === 4) presc = { tag: "snail",   name: { es: "Mucina de Caracol Regeneradora", en: "Regenerating Snail Mucin", ko: "피부 재생 달팽이 점액" } };
  }
  if (stepNum === 3) {
    if (currentConcern === 'redness')  presc = { tag: "centella",    name: { es: "Centella Asiática Calmadora",     en: "Soothing Centella Asiatica",    ko: "피부 진정 병풀추출물"       } };
    if (currentConcern === 'dullness') presc = { tag: "niacinamide", name: { es: "Niacinamida Iluminadora",         en: "Brightening Niacinamide",        ko: "기미 완화 나이아신아마이드"  } };
    if (currentConcern === 'dryness')  presc = { tag: "hyaluronic",  name: { es: "Ácido Hialurónico Hidratante",   en: "Hydrating Hyaluronic Acid",      ko: "수분 보습 히알루론산"       } };
    if (currentConcern === 'poros')    presc = { tag: "propolis",    name: { es: "Propóleo Refinador de Poros",    en: "Pore-Refining Propolis",          ko: "모공 정돈 프로폴리스"       } };
    if (currentConcern === 'firmeza')  presc = { tag: "ginseng",     name: { es: "Ginseng Reafirmante",            en: "Firming Ginseng Extract",         ko: "탄력 케어 인삼 추출물"      } };
    if (currentConcern === 'ojeras')   presc = { tag: "niacinamide", name: { es: "Niacinamida Antiojeras",         en: "Niacinamide (Dark Circles)",      ko: "다크서클 완화 나이아신아마이드" } };
  }
  return presc;
}

// ── 저녁 2중 세안 라벨 ──────────────────────────────────────────────────
const DOUBLE_CLEANSE_LABELS = {
  oil:   { es: 'Limpieza con Aceite', en: 'Oil Cleanse',  ko: '오일 클렌징 (1차)' },
  water: { es: 'Limpieza con Espuma', en: 'Foam Cleanse', ko: '폼 클렌징 (2차)' }
};
function _cleanseLabel(kind) {
  return DOUBLE_CLEANSE_LABELS[kind][currentLang] || DOUBLE_CLEANSE_LABELS[kind].es;
}

// ── 단계별 제품 점수 가중치 (단계 성격에 맞게 차등) ──────────────────────
// type=피부타입 / c1=1순위 고민 / c2=2순위 고민 / age=나이
// 클렌저·선크림=타입 중심, 세럼·각질·마스크=고민 중심, 크림·아이크림=나이(영양·안티에이징) 중심
const SKINQUIZ_STEP_WEIGHTS = {
  1: { type: 3,   c1: 1,   c2: 0.5, age: 1   }, // 클렌저
  2: { type: 2.5, c1: 2,   c2: 1,   age: 1   }, // 토너
  3: { type: 2,   c1: 3,   c2: 1.5, age: 1.5 }, // 세럼/에센스
  4: { type: 2.5, c1: 2,   c2: 1,   age: 2   }, // 크림
  5: { type: 3,   c1: 1,   c2: 0.5, age: 1   }, // 선크림
  6: { type: 1.5, c1: 3,   c2: 1.5, age: 1   }, // 각질
  7: { type: 1.5, c1: 3,   c2: 1.5, age: 1.5 }, // 마스크
  8: { type: 1,   c1: 2,   c2: 1,   age: 3   }  // 아이크림
};
// 고민 점수 조회: 'dullness'(칙칙함/색소침착, 사용자에겐 단일 문항)는 내부적으로
// Luminosidad(concern-dullness)와 Manchas(concern-manchas) 두 컬렉션 태그를 OR로 묶어서 판정한다.
// (collections_taxonomy.md 상 두 컬렉션이 분리돼 있어 Manchas 전용 태그 제품도 놓치지 않기 위함.
//  기존 제품은 전부 concern-manchas 미태그라 Math.max가 항상 dullness값과 같음 = 회귀 없음.)
function _concernVal(product, concern) {
  if (!concern) return 0;
  const cs = product.concernScore || {};
  if (concern === 'dullness') return Math.max(cs.dullness || 0, cs.manchas || 0);
  return cs[concern] || 0;
}
function skinquizScore(product, skinType, concern1, concern2, age, stepNum, experience) {
  const w = SKINQUIZ_STEP_WEIGHTS[stepNum] || { type: 3, c1: 2, c2: 1, age: 1 };
  let s = (product.skinTypeScore[skinType]            || 0) * w.type
        + (concern1 ? _concernVal(product, concern1) * w.c1 : 0)
        + (concern2 ? _concernVal(product, concern2) * w.c2 : 0)
        + (product.ageScore[age]                      || 0) * w.age;
  // 핵심 성분 함유 보너스: 고민의 hero 성분(핵심성분 카드와 동일)을 담은 제품을 루틴이 우선 추천
  const tags = product.ingredientsTags || [];
  const h1 = concern1 && CONCERN_KEY_INGREDIENTS[concern1] && CONCERN_KEY_INGREDIENTS[concern1].tag;
  const h2 = concern2 && CONCERN_KEY_INGREDIENTS[concern2] && CONCERN_KEY_INGREDIENTS[concern2].tag;
  if (h1 && tags.includes(h1)) s += 3;
  if (h2 && tags.includes(h2)) s += 1.5;
  // 경험 수준(액티브 내성) 보정: "숙련" 답변이면 레티놀 함유 제품을 피부타입과 무관하게 우선 노출,
  // "초보" 답변이면 순한 루틴을 우선하도록 살짝 낮춤(하드 제외는 아님 — 안전 필터는 q7에서 별도 처리).
  if (product.hasRetinoid) {
    if (experience === 'experienced') s += 2.5;
    else if (experience === 'beginner') s -= 1.5;
  }
  // 성숙 피부(Piel Madura) 보정: 4개 기본 타입과 배타적이지 않은 추가 신호.
  // 30대는 절반, 40대는 전체 가중치로 skin-madura 태그 제품에 나이 가중치(w.age)만큼 가산 —
  // 오직 skin-madura만 있고 dry/oily/combo/sensitive 태그가 없는 제품(순수 안티에이징 라인)도
  // 나이대 매칭 신호를 받도록 함. 10대/20대는 0(해당 없음).
  const maduraAffinity = age === 'forties' ? 1 : (age === 'thirties' ? 0.5 : 0);
  if (maduraAffinity && product.maduraScore) s += product.maduraScore * maduraAffinity * w.age;
  // 스틱형 선크림 감점(step 5 전용): 메이크업 여부와 무관하게 기본적으로 메인 추천에서 밀리게 함.
  // 하드 제외가 아니라 감점이라 크림/세럼형 대안이 없으면 그래도 추천될 수 있음(대체품 0 방지).
  if (stepNum === 5 && product.sunscreenTexture === 'stick') s -= 3;
  return s;
}
window.skinquizScore = skinquizScore;

// 메인 단계 렌더 계획. 저녁(PM)은 1단계를 오일→폼 2중 세안으로 분리한다.
// 각 항목: { stepNum(점수/성분용 의미상 단계), cleanserKind, label, displayNum(표시 번호) }
function _buildStepPlan(isAM) {
  const plan = [];
  if (isAM) {
    [1, 2, 3, 4, 5].forEach(s => {
      if (s === 1 && (detectedSkinType === 'dry' || detectedSkinType === 'sensitive')) return; // 물세안 대체
      plan.push({ stepNum: s, displayNum: s });
    });
  } else {
    let dn = 1;
    plan.push({ stepNum: 1, cleanserKind: 'oil',   label: _cleanseLabel('oil'),   displayNum: dn++ });
    plan.push({ stepNum: 1, cleanserKind: 'water', label: _cleanseLabel('water'), displayNum: dn++ });
    [2, 3, 4].forEach(s => plan.push({ stepNum: s, displayNum: dn++ })); // 선크림(5) 제외
  }
  return plan;
}

// 2순위 고민 집중 케어 라벨
function _secondaryCareLabel(concern) {
  const name = CONCERN_NAMES[currentLang]?.[concern] || concern;
  return currentLang === 'ko' ? `🎯 ${name} 집중 케어`
       : currentLang === 'en' ? `🎯 Targeted care: ${name}`
       : `🎯 Cuidado extra: ${name}`;
}

const TREATMENT_LABEL = { es: '✨ Tratamiento Extra', en: '✨ Extra Treatment', ko: '✨ 보완 트리트먼트' };
function _treatmentLabel() { return TREATMENT_LABEL[currentLang] || TREATMENT_LABEL.es; }

// 트리트먼트 카드 전용 설명 — 일반 보습크림용(피부타입별) 문구를 재사용하면 내용이 안 맞아서 별도 문구 사용
const TREATMENT_WHY_TEXT = {
  es: 'Este tratamiento no sustituye tu crema hidratante habitual — úsalo como paso extra encima de ella.',
  en: 'This treatment doesn\'t replace your regular moisturizer — use it as an extra step on top of it.',
  ko: '이 제품은 일반 보습크림을 대체하지 않아요 — 기존 크림 위에 추가로 사용하는 보완 단계예요.'
};

// 보완 단계 계획(밤 위주). 2순위 고민에 전용 단계가 없으면 '2순위 집중 세럼'을 추가해
// 두 고민이 모두 실제 추천 제품으로 반영되게 한다.
function _buildExtraJobs(isAM, concernArr, maxMainDisplay) {
  // 전용 보완 제품이 있는 고민: 아이크림(step-6)이 다크서클·탄력을 담당.
  const COVERED = ['ojeras', 'firmeza'];
  const secondary = concernArr[1];
  const jobs = [];
  // 2순위 집중 트리트먼트 (전용 제품 없는 고민: dryness/acne/redness/dullness/poros) — 밤
  if (!isAM && secondary && !COVERED.includes(secondary)) {
    jobs.push({ stepNum: 3, concernOverride: secondary, label: _secondaryCareLabel(secondary) });
  }
  // 아이크림(step-6): 다크서클/탄력 고민일 때
  if (concernArr.some(c => ['ojeras', 'firmeza'].includes(c))) jobs.push({ stepNum: 6 });
  // 마스크(step-7): 저녁 루틴에 항상
  if (!isAM) jobs.push({ stepNum: 7 });
  // 트리트먼트 크림(skinquiz:treatment 태그 제품, 있을 때만 카드 노출) — 보습크림을 대체하지 않는 보완 제품
  jobs.push({ stepNum: 4, variant: 'treatment', label: _treatmentLabel(), isTreatmentJob: true });
  jobs.forEach((j, i) => { j.displayNum = maxMainDisplay + 1 + i; j.extra = true; });
  return jobs;
}

// 필름형/PLA 트리트먼트 크림 + 스틱/왁스형 선크림 병용 시 밀림(pilling) 경고
const TREATMENT_CONFLICT_WARN = {
  es: '⚠️ Este tratamiento puede generar bolitas (pilling) si lo combinas con protectores solares en stick o cera. Prueba con un protector tipo sérum.',
  en: '⚠️ This treatment may pill when combined with stick or wax-based sunscreens. Try a serum-type sunscreen instead.',
  ko: '⚠️ 이 트리트먼트는 스틱/왁스형 선크림과 함께 쓰면 밀릴 수 있어요. 세럼 타입 선크림을 추천드려요.'
};
// 트리트먼트 크림(현재 전량 탄력/성숙피부 대상)이 이 사용자와 무관하면 카드 자체를 숨긴다.
// 태그 근거 없이 무조건 노출되던 버그 수정 — 예: 10대 여드름 고민 사용자에게 40대용 탄력 밤이 뜨던 문제.
function _isTreatmentRelevant(product, concern1, concern2, age) {
  const maduraAffinity = age === 'forties' ? 1 : (age === 'thirties' ? 0.5 : 0);
  return (product.ageScore?.[age] || 0) > 0
      || (maduraAffinity > 0 && (product.maduraScore || 0) > 0)
      || _concernVal(product, concern1) > 0
      || (concern2 && _concernVal(product, concern2) > 0);
}
function _filterIrrelevantTreatment(results, concern1, concern2, age) {
  const treat = results.find(r => r.isTreatmentJob);
  if (treat && treat.best && !_isTreatmentRelevant(treat.best, concern1, concern2, age)) {
    treat.best = null; // 무관하면 조용히 카드 생략(태그 없을 때와 동일한 동작)
    treat.alternatives = [];
  }
}

function _appendTreatmentConflictWarning(results) {
  const treat = results.find(r => r.isTreatmentJob && r.best);
  const sun   = results.find(r => r.stepNum === 5 && r.best);
  if (treat && sun && sun.best.sunscreenTexture === 'stick') {
    treat.conflictWarning = TREATMENT_CONFLICT_WARN[currentLang] || TREATMENT_CONFLICT_WARN.es;
  }
}

// 2순위 집중 세럼이 메인 세럼과 동일 제품이면 대체품으로 교체(중복 방지)
function _dedupSecondaryTreatment(results) {
  const mainSerum = results.find(r => !r.extra && r.stepNum === 3 && r.best);
  const treat     = results.find(r => r.extra && r.concernOverride && r.best);
  if (mainSerum && treat && mainSerum.best.id === treat.best.id) {
    if (treat.alternatives && treat.alternatives.length) {
      treat.best = treat.alternatives[0];
      treat.alternatives = treat.alternatives.slice(1);
    } else {
      treat.best = null; // 대체 제품 없으면 생략
    }
  }
}

async function renderRoutineTimeline() {
  const productList = document.getElementById('routine-products-list');

  const waterOnlyCard = document.getElementById('water-only-card');
  if (selectedRoutineTab === 'dia' && (detectedSkinType === 'dry' || detectedSkinType === 'sensitive')) {
    waterOnlyCard.style.display = 'flex';
  } else {
    waterOnlyCard.style.display = 'none';
  }

  const isAM = selectedRoutineTab === 'dia';
  const safetyOptions = answers['q7_safety_filters'] || [];
  const currentConcern = answers['q5_concern'];
  const preferredSunType = answers['q8_sunscreen'];
  const makeupUsed = answers['q9_makeup']; // 'yes'/'no' — 선크림 텍스처 필터용
  const experience = answers['q10_experience']; // 'beginner'/'experienced' — 레티놀 등 액티브 점수 보정용
  const concernArr = Array.isArray(currentConcern) ? currentConcern : (currentConcern ? [currentConcern] : []);

  const mainPlan = _buildStepPlan(isAM);
  const maxMainDisplay = Math.max(...mainPlan.map(j => j.displayNum), 0);
  const extraJobs = _buildExtraJobs(isAM, concernArr, maxMainDisplay);

  // 렌더 작업 목록 (메인 단계 + 보완 단계). 저녁이면 메인에 오일/폼 2중 세안 포함.
  const jobs = [
    ...mainPlan.map(j => ({ ...j, extra: false })),
    ...extraJobs
  ];

  // ── Shopify API 모드 ──────────────────────────────────────────────────
  if (window.shopifyQuiz && window.shopifyQuiz.isConfigured()) {
    productList.innerHTML = mainPlan.map((j, i) => `
      <div class="product-card-skeleton" id="skel-${i}">
        <div class="skel-bar skel-bar--sm"></div>
        <div class="skel-bar skel-bar--icon"></div>
        <div style="display:flex;gap:16px;margin-bottom:14px;">
          <div class="skel-img"></div>
          <div style="flex:1;display:flex;flex-direction:column;gap:8px;justify-content:center;">
            <div class="skel-bar skel-bar--xs"></div>
            <div class="skel-bar skel-bar--md"></div>
            <div class="skel-bar skel-bar--xs"></div>
          </div>
        </div>
        <div class="skel-bar skel-bar--lg"></div>
        <div class="skel-bar skel-bar--btn"></div>
      </div>
    `).join('');

    try {
      const results = await Promise.all(
        jobs.map(job =>
          window.shopifyQuiz.getProductsForStep(
            job.stepNum, isAM, detectedSkinType, job.concernOverride || currentConcern, userAge,
            safetyOptions, job.stepNum === 5 ? preferredSunType : null, job.cleanserKind || null,
            job.variant || null, job.stepNum === 5 ? makeupUsed : null, experience
          ).then(r => ({ ...job, ...r }))
        )
      );

      _dedupSecondaryTreatment(results); // 2순위 집중 세럼이 메인 세럼과 같으면 대체품으로
      _filterIrrelevantTreatment(results, concernArr[0], concernArr[1], userAge); // 무관한 트리트먼트(예: 10대에게 탄력 밤) 숨김
      _appendTreatmentConflictWarning(results); // 필름형 트리트먼트 + 스틱 선크림 병용 경고

      productList.innerHTML = '';

      results.filter(r => !r.extra).forEach(r => {
        if (!r.best) return;
        renderProductCard(productList, r.stepNum, r.best, r.alternatives, r.displayNum, r.label, r.concernOverride, _stepTier(r.stepNum, false));
      });

      const extraResults = results.filter(r => r.extra && r.best);
      if (extraResults.length > 0) {
        _renderComplementosDivider(productList);
        extraResults.forEach(r => {
          renderProductCard(productList, r.stepNum, r.best, r.alternatives, r.displayNum, r.label, r.concernOverride, 'completo', r.conflictWarning, r.isTreatmentJob);
        });
      }

      const tabList = results
        .filter(r => r.best)
        .map(r => ({
          step: r.displayNum,
          stepName: r.label || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[r.stepNum] || `Paso ${r.displayNum}`,
          brand: r.best.brand,
          productName: r.best.name,
          image: r.best.imageUrl || '',
          price: r.best.price || '',
          url: r.best.link || ''
        }));
      if (isAM) _recommendedProductListAM = tabList;
      else       _recommendedProductListPM = tabList;

      _applyTierFilter();
    } catch (e) {
      console.error('[Routine] Shopify 오류:', e);
      productList.innerHTML = '';
    }

    return;
  }

  // ── 로컬 fallback ─────────────────────────────────────────────────────
  productList.innerHTML = '';
  const allProducts = window.productsDatabase.getProducts();

  const renderLocalStep = (stepNum, displayNum, cleanserKind, label, concernOverride, excludeId, tier, variant, conflictWarning, isTreatmentJob) => {
    const presc = _getStepPrescription(stepNum);
    let candidates = allProducts.filter(p => {
      if (p.step !== stepNum) return false;
      if (isAM && !p.isDia) return false;
      if (!isAM && !p.isNoche) return false;
      return true;
    });
    if (safetyOptions.includes('pregnancy')) candidates = candidates.filter(p => p.pregnancySafe);
    if (safetyOptions.includes('fragrance')) candidates = candidates.filter(p => p.fragranceFree);
    if (detectedSkinType === 'sensitive') { const ff = candidates.filter(p => p.fragranceFree); if (ff.length) candidates = ff; }
    if (stepNum === 5) candidates = candidates.filter(p => p.sunscreenType === preferredSunType);
    if (stepNum === 5 && makeupUsed === 'yes') {
      const noStick = candidates.filter(p => p.sunscreenTexture !== 'stick');
      if (noStick.length) candidates = noStick;
    }
    // 클렌저 종류 필터: 오일(cleanserType==='oil') / 그 외(폼·워터·미태그)
    if (stepNum === 1) {
      if (cleanserKind === 'oil') candidates = candidates.filter(p => p.cleanserType === 'oil');
      else                        candidates = candidates.filter(p => p.cleanserType !== 'oil');
    }
    // 트리트먼트 크림 분리(step 4): variant='treatment'면 트리트먼트만, 기본은 제외
    if (stepNum === 4) {
      if (variant === 'treatment') candidates = candidates.filter(p => p.isTreatment);
      else                         candidates = candidates.filter(p => !p.isTreatment);
    }
    if (excludeId) candidates = candidates.filter(p => p.id !== excludeId); // 중복 제외
    // 점수용 고민: 2순위 집중 케어면 override를 1순위로
    const c1 = concernOverride || concernArr[0];
    const c2 = concernOverride ? null : concernArr[1];
    // 2순위 집중 케어는 성분 prescription 필터 생략(고민 점수로만 선택)
    let matches = concernOverride ? candidates : candidates.filter(p => p.ingredientsTags && p.ingredientsTags.includes(presc?.tag));
    if (matches.length === 0) matches = candidates;
    if (matches.length === 0) return false;
    const scored = matches.map(p => ({
      product: p,
      score: skinquizScore(p, detectedSkinType, c1, c2, userAge, stepNum, experience)
    }));
    scored.sort((a, b) => b.score - a.score);
    if (isTreatmentJob && !_isTreatmentRelevant(scored[0].product, c1, c2, userAge)) return false; // 무관한 트리트먼트 숨김
    renderProductCard(productList, stepNum, scored[0].product, scored.slice(1, 3).map(x => x.product), displayNum, label, concernOverride, tier, conflictWarning, isTreatmentJob);
    return scored[0].product;
  };

  const localProducts = [];
  let mainSerumId = null;
  let step5Texture = null;
  mainPlan.forEach(j => {
    const p = renderLocalStep(j.stepNum, j.displayNum, j.cleanserKind, j.label, null, null, _stepTier(j.stepNum, false));
    if (p) {
      if (j.stepNum === 3) mainSerumId = p.id;
      if (j.stepNum === 5) step5Texture = p.sunscreenTexture || null;
      localProducts.push({
        step: j.displayNum,
        stepName: j.label || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[j.stepNum] || `Paso ${j.displayNum}`,
        product: p
      });
    }
  });

  extraJobs.forEach(j => {
    const excludeId = j.concernOverride ? mainSerumId : null; // 2순위 세럼은 메인 세럼과 다른 제품
    const conflictWarning = (j.isTreatmentJob && step5Texture === 'stick')
      ? (TREATMENT_CONFLICT_WARN[currentLang] || TREATMENT_CONFLICT_WARN.es) : null;
    const p = renderLocalStep(j.stepNum, j.displayNum, j.cleanserKind, j.label, j.concernOverride, excludeId, 'completo', j.variant, conflictWarning, j.isTreatmentJob);
    if (p) localProducts.push({
      step: j.displayNum,
      stepName: j.label || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[j.stepNum] || `Paso ${j.displayNum}`,
      product: p
    });
  });

  const localTabList = localProducts.map(({ step, stepName, product }) => ({
    step,
    stepName,
    brand: product.brand,
    productName: product.name,
    image: product.imageUrl || '',
    price: product.price || '',
    url: product.link || ''
  }));
  if (isAM) _recommendedProductListAM = localTabList;
  else       _recommendedProductListPM = localTabList;

  _applyTierFilter();
}

function _renderComplementosDivider(container) {
  const labels = { es: '🌿 Complementos recomendados', en: '🌿 Recommended Extras', ko: '🌿 추천 보완 제품' };
  const subs = { es: 'Tratamientos específicos · Uso semanal', en: 'Targeted treatments · Weekly use', ko: '집중 케어 · 주 1-2회 사용' };
  const div = document.createElement('div');
  div.className = 'complementos-divider';
  div.innerHTML = `
    <div class="complementos-divider-inner">
      <span class="complementos-label">${labels[currentLang] || labels.es}</span>
      <span class="complementos-sub">${subs[currentLang] || subs.es}</span>
    </div>
  `;
  container.appendChild(div);
}

// 제품 링크에 UTM 추적 파라미터 부착 (퀴즈 유입 세션 추적용)
function _withUtm(url) {
  if (!url) return url || '';
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}utm_source=skinquiz&utm_medium=quiz&utm_campaign=skin-result`;
}

// 티어(필수/추천/전체) 분류: 클렌저·크림·선크림=필수, 토너·세럼=추천, 나머지(보완단계)=전체
function _stepTier(stepNum, isExtra) {
  if (isExtra) return 'completo';
  if (stepNum === 1 || stepNum === 4 || stepNum === 5) return 'esencial';
  return 'recomendado';
}

function renderProductCard(container, stepNum, product, alternatives, displayNum, labelOverride, concernOverride, tier, conflictWarning, isTreatmentJob) {
  const card = document.createElement('div');
  card.className = 'product-card';
  if (stepNum >= 6) card.classList.add('product-card--extra');
  card.dataset.tier = tier || _stepTier(stepNum, stepNum >= 6);
  card.dataset.price = product.price || '0';

  const dispNum = displayNum || stepNum;
  const typeName = labelOverride || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[stepNum] || `Paso ${dispNum}`;
  let stepLabel;
  if (currentLang === 'ko') {
    stepLabel = `${dispNum}단계: ${typeName}`;
  } else if (currentLang === 'en') {
    stepLabel = `Step ${dispNum}: ${typeName}`;
  } else {
    stepLabel = `Paso ${dispNum}: ${typeName}`;
  }

  const name = product.name;
  const brand = product.brand;
  const price = product.price;
  const link = product.link;
  const desc = product.description[currentLang] || product.description['es'];
  const keyIng = product.keyIngredients[currentLang] || product.keyIngredients['es'];
  const img = product.imageUrl;

  let alternativesHtml = '';
  if (alternatives.length > 0) {
    const altTitle = i18n[currentLang]['other_options'];
    const comprarLabel = i18n[currentLang]['comprar'];
    
    const altItemsHtml = alternatives.map(alt => `
      <div class="alternative-item">
        <img src="${alt.imageUrl}" class="alt-image" alt="${alt.name}">
        <div class="alt-info">
          <div class="alt-name">${alt.brand} - ${alt.name}</div>
          <div class="alt-price">${alt.price}€</div>
          <a href="${_withUtm(alt.link)}" target="_blank" class="btn-alt-buy">${comprarLabel}</a>
        </div>
      </div>
    `).join('');

    alternativesHtml = `
      <div class="alternatives-accordion">
        <button class="accordion-header" onclick="toggleAccordion(this)">
          <span>✨ ${altTitle} (+${alternatives.length})</span>
          <span class="accordion-arrow">▼</span>
        </button>
        <div class="accordion-content">
          ${altItemsHtml}
        </div>
      </div>
    `;
  }

  const buyBtnLabel = i18n[currentLang]['comprar'];

  let whyText = (stepWhyTexts[currentLang]?.[stepNum]?.[detectedSkinType]) || '';
  // 트리트먼트 카드: 일반 step-4(보습크림, 피부타입별) 문구가 안 맞으므로 전용 문구로 교체
  if (isTreatmentJob) {
    whyText = TREATMENT_WHY_TEXT[currentLang] || TREATMENT_WHY_TEXT.es;
  }
  // 2순위 집중 케어 카드: 그 고민 기준 설명으로 대체 (일반 세럼/1순위 설명 방지)
  if (concernOverride) {
    const cn = CONCERN_NAMES[currentLang]?.[concernOverride] || concernOverride;
    whyText = currentLang === 'ko' ? `2순위 고민 '${cn}'을(를) 집중 케어하는 추가 트리트먼트예요.`
            : currentLang === 'en' ? `An extra targeted treatment for your secondary concern: ${cn}.`
            : `Un tratamiento extra enfocado en tu segunda preocupación: ${cn}.`;
  }

  // ── "왜 이 제품인가요?" 섹션 ────────────────────────────────────────────────
  const concernArr = Array.isArray(answers['q5_concern'])
    ? answers['q5_concern']
    : (answers['q5_concern'] ? [answers['q5_concern']] : []);
  const primaryConcern = concernArr[0] || '';

  // 성분 효능 불릿 (ingredientHighlights 배열 사용)
  const highlights = product.ingredientHighlights || [];
  const ingBulletsHtml = highlights
    .filter(h => h.name && h.benefit)
    .map(h => {
      const n = h.name[currentLang] || h.name.es;
      const b = h.benefit[currentLang] || h.benefit.es;
      return `<li class="why-ing"><strong>${n}</strong>${b ? ` — ${b}` : ''}</li>`;
    })
    .join('');

  // 고민 맞춤 문장 (집중 케어 카드는 해당 2순위 고민 기준, 트리트먼트 카드는 사용자 1순위 고민과 무관할 수 있어 생략)
  const bestConcern = isTreatmentJob ? '' : (concernOverride || concernArr[0] || '');
  const concernReason = bestConcern ? (CONCERN_REASONS[currentLang]?.[bestConcern] || '') : '';
  const concernHtml = concernReason ? `<li class="why-concern">🎯 ${concernReason}</li>` : '';

  // 안전 필터 뱃지
  const safetyBadges = [];
  if (product.fragranceFree)  safetyBadges.push(currentLang === 'ko' ? '무향' : (currentLang === 'en' ? 'Fragrance-Free' : 'Sin Fragancia'));
  if (product.pregnancySafe)  safetyBadges.push(currentLang === 'ko' ? '임산부 안심' : (currentLang === 'en' ? 'Pregnancy-Safe' : 'Apto Embarazo'));
  const safetyHtml = safetyBadges.length
    ? `<li class="why-safety">${safetyBadges.map(b => `<span class="why-badge">${b}</span>`).join('')}</li>`
    : '';

  const whyHeader = currentLang === 'ko' ? '💡 왜 이 제품인가요?' : (currentLang === 'en' ? '💡 Why this for you?' : '💡 ¿Por qué para ti?');
  const whySectionHtml = (ingBulletsHtml || concernHtml || safetyHtml) ? `
    <div class="product-why">
      <p class="product-why-header">${whyHeader}</p>
      <ul class="product-why-list">
        ${ingBulletsHtml}
        ${concernHtml}
        ${safetyHtml}
      </ul>
    </div>` : '';

  card.innerHTML = `
    <div class="step-indicator">${stepLabel}</div>
    ${whyText ? `<p class="step-why-text">${whyText}</p>` : ''}
    <div class="product-info-grid">
      <img src="${img}" class="product-image" alt="${name}">
      <div class="product-details">
        <span class="product-brand">${brand}</span>
        <h3 class="product-name">${name}</h3>
        <span class="product-price">${price}€</span>
        ${keyIng ? `<div class="product-tags" style="margin-top:6px;"><span class="tag-badge ingredient">✦ ${keyIng}</span></div>` : ''}
      </div>
    </div>
    <div class="product-action-row">
      ${product.variantId
        ? `<button class="btn-buy" data-stepname="${_escapeHtml(stepLabel)}" onclick="addToCart(${product.variantId}, this)">${buyBtnLabel}</button>`
        : `<a href="${_withUtm(link)}" target="_blank" class="btn-buy">${buyBtnLabel}</a>`}
    </div>
    ${conflictWarning ? `<div class="product-conflict-warning">${conflictWarning}</div>` : ''}
    ${whySectionHtml}
    ${alternativesHtml}
  `;

  container.appendChild(card);
}

function addToCart(variantId, btnEl) {
  if (!variantId) { console.warn('[Cart] variantId 없음'); return; }
  console.log('[Cart] 담기 시도 variantId:', variantId);
  const original = btnEl.textContent;
  btnEl.disabled = true;
  btnEl.textContent = '...';

  // 전환 추적: 퀴즈 추천 마커를 주문 라인에 기록 (_ 접두사 = 고객엔 숨김, 주문엔 저장)
  const concernRaw = answers['q5_concern'];
  const concernStr = Array.isArray(concernRaw) ? concernRaw.join(',') : (concernRaw || '');
  const lineProps = {
    '_skinquiz': 'recommended',
    '_skinquiz_skin_type': detectedSkinType || '',
    '_skinquiz_concern': concernStr,
    '_skinquiz_age': userAge || '',
    '_skinquiz_step': (btnEl.dataset && btnEl.dataset.stepname) || ''
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: lineProps }] })
  })
  .then(r => {
    console.log('[Cart] 응답 status:', r.status);
    return r.json();
  })
  .then(data => {
    console.log('[Cart] 응답:', data);
    if (data.status && data.status >= 400) throw new Error(data.description);
    btnEl.textContent = currentLang === 'ko' ? '✓ 담겼어요' : (currentLang === 'en' ? '✓ Added' : '✓ Añadido');
    setTimeout(() => { btnEl.disabled = false; btnEl.textContent = original; }, 2500);
    // Horizon 테마 카트 카운트 즉시 업데이트
    fetch('/?sections=header-group').then(r => r.json()).then(sections => {
      const html = sections['header-group'];
      if (!html) return;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newHeader = doc.getElementById('shopify-section-header-group');
      const curHeader = document.getElementById('shopify-section-header-group');
      if (newHeader && curHeader) curHeader.innerHTML = newHeader.innerHTML;
    }).catch(() => {});
  })
  .catch(err => {
    console.error('[Cart] 실패:', err);
    btnEl.disabled = false;
    btnEl.textContent = original;
  });
}

function toggleAccordion(button) {
  button.classList.toggle('active');
  const content = button.nextElementSibling;
  if (content.style.display === 'flex' || content.style.display === 'block') {
    content.style.display = 'none';
  } else {
    content.style.display = 'flex';
  }
}

// ==================== 10. 공유 및 유틸리티 ====================
function copyResultLink() {
  const q5ForUrl = answers['q5_concern'];
  const concernStr = Array.isArray(q5ForUrl) ? q5ForUrl.join(',') : (q5ForUrl || '');
  const shareUrl = `${window.location.origin}${window.location.pathname}?name=${encodeURIComponent(userName)}&type=${detectedSkinType}&concern=${encodeURIComponent(concernStr)}`;
  
  navigator.clipboard.writeText(shareUrl).then(() => {
    alert(currentLang === 'ko' ? '결과 확인 링크가 클립보드에 복사되었습니다! 인스타 DM으로 전송해 보세요.' : (currentLang === 'en' ? 'Result link copied to clipboard! Share it on Instagram DM.' : '¡Enlace de diagnóstico copiado al portapapeles! Envíalo por Instagram DM.'));
  }).catch(() => {
    alert(shareUrl);
  });
}

// ==================== 10b. 이메일 구독 (결과 화면 옵트인) ====================
function _escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _emailLabels() {
  const L = {
    es: { greeting: n => `¡Hola, ${n}! 👋`, intro: 'Aquí tienes tu diagnóstico de piel personalizado de <b>21hermosa</b>.',
          typeLabel: 'TU TIPO DE PIEL', routineLabel: 'TU RUTINA PERSONALIZADA',
          am: '☀️ Rutina de Mañana (AM)', pm: '🌙 Rutina de Noche (PM)', buy: 'Comprar',
          cta: 'Comprar mis productos recomendados →', concernLabel: 'Tus prioridades' },
    en: { greeting: n => `Hi, ${n}! 👋`, intro: 'Here is your personalized skin diagnosis from <b>21hermosa</b>.',
          typeLabel: 'YOUR SKIN TYPE', routineLabel: 'YOUR PERSONALIZED ROUTINE',
          am: '☀️ Morning Routine (AM)', pm: '🌙 Night Routine (PM)', buy: 'Shop',
          cta: 'Shop my recommended products →', concernLabel: 'Your priorities' },
    ko: { greeting: n => `${n}님, 안녕하세요! 👋`, intro: '<b>21hermosa</b>의 맞춤 피부 진단 결과를 보내드려요.',
          typeLabel: '나의 피부 타입', routineLabel: '맞춤 루틴',
          am: '☀️ 아침 루틴 (AM)', pm: '🌙 저녁 루틴 (PM)', buy: '구매하기',
          cta: '추천 제품 보러 가기 →', concernLabel: '나의 피부 고민' }
  };
  return L[currentLang] || L.es;
}

// 평문 루틴 (구글시트 기록 / EmailJS 폴백용)
function _buildRoutineText() {
  const lbl = _emailLabels();
  const sectionToText = (label, rows) => {
    if (!rows || !rows.length) return '';
    const lines = rows.map(r => {
      const stepName = r.stepName || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[r.step] || `Paso ${r.step}`;
      return `${r.step}. ${stepName}: ${r.brand ? r.brand + ' ' : ''}${r.productName}${r.price ? ` (${r.price}€)` : ''}`;
    });
    return `${label}\n${lines.join('\n')}`;
  };
  return [sectionToText(lbl.am, _recommendedProductListAM), sectionToText(lbl.pm, _recommendedProductListPM)]
    .filter(Boolean).join('\n\n');
}

// 제품 이미지가 포함된 HTML 이메일 본문 (EmailJS 템플릿에서 {{{email_body}}} 로 렌더)
function _buildRoutineEmailHtml() {
  const lbl     = _emailLabels();
  const c       = SKIN_TYPE_COLORS[detectedSkinType] || SKIN_TYPE_COLORS.combination;
  const skinKey = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
  const profile = SKIN_TYPE_PROFILES[detectedSkinType] || {};
  const typeName = i18n[currentLang][`skin_${skinKey}`] || detectedSkinType;
  const desc     = i18n[currentLang][`desc_${skinKey}`] || '';
  const emoji    = profile.emoji || '✨';

  const concernRaw = answers['q5_concern'];
  const concernArr = Array.isArray(concernRaw) ? concernRaw : (concernRaw ? [concernRaw] : []);
  const concernNames = concernArr.map(cc => CONCERN_NAMES[currentLang]?.[cc] || cc).join(' · ');

  const productRow = (r) => {
    const stepName = (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[r.step] || `Paso ${r.step}`;
    const stepLabel = currentLang === 'ko' ? `${r.step}단계 · ${stepName}`
                    : currentLang === 'en' ? `Step ${r.step} · ${stepName}`
                    : `Paso ${r.step} · ${stepName}`;
    const img = r.image
      ? `<img src="${_escapeHtml(r.image)}" width="64" height="64" alt="" style="display:block;width:64px;height:64px;border-radius:10px;object-fit:cover;background:#f4f4f4;">`
      : `<div style="width:64px;height:64px;border-radius:10px;background:${c.light};"></div>`;
    const buyBtn = r.url
      ? `<a href="${_escapeHtml(r.url)}" target="_blank" style="display:inline-block;background:${c.main};color:#ffffff;text-decoration:none;font-size:12px;font-weight:700;padding:9px 14px;border-radius:8px;white-space:nowrap;">${lbl.buy}</a>`
      : '';
    return `
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 10px;background:#ffffff;border:1px solid #eeeeee;border-radius:12px;">
        <tr>
          <td width="88" valign="top" style="padding:14px 10px 14px 14px;">${img}</td>
          <td valign="middle" style="padding:14px 8px 14px 0;">
            <div style="font-size:11px;font-weight:700;color:${c.text};letter-spacing:.3px;text-transform:uppercase;">${_escapeHtml(stepLabel)}</div>
            <div style="font-size:14px;font-weight:700;color:#1a1a1a;line-height:1.35;margin:3px 0 2px;">${_escapeHtml(r.productName)}</div>
            <div style="font-size:12px;color:#999999;">${_escapeHtml(r.brand || '')}${r.price ? ` · ${_escapeHtml(r.price)}€` : ''}</div>
          </td>
          <td width="92" valign="middle" align="right" style="padding:14px 14px 14px 4px;">${buyBtn}</td>
        </tr>
      </table>`;
  };

  const section = (title, rows, isAM) => {
    if (!rows || !rows.length) return '';
    const bg = isAM ? c.main : '#3D4F63';
    return `
      <div style="margin:22px 0 10px;background:${bg};color:#ffffff;font-size:14px;font-weight:700;padding:11px 16px;border-radius:10px;">${title}</div>
      ${rows.map(productRow).join('')}`;
  };

  const concernBlock = concernNames ? `
    <div style="margin:6px 0 0;font-size:13px;color:#666666;"><b style="color:${c.text};">${lbl.concernLabel}:</b> ${_escapeHtml(concernNames)}</div>` : '';

  return `
  <div style="margin:0;padding:0;background:#f8f9fc;">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f8f9fc;padding:0;">
      <tr><td align="center" style="padding:24px 12px;">
        <table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background:#ffffff;border-radius:18px;overflow:hidden;font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">
          <!-- 헤더 -->
          <tr><td style="background:${c.main};padding:28px 24px;text-align:center;">
            <div style="font-size:26px;font-weight:800;color:#ffffff;letter-spacing:.5px;">21hermosa</div>
            <div style="font-size:13px;color:rgba(255,255,255,.85);margin-top:4px;">K-Beauty Skin Diagnosis</div>
          </td></tr>
          <!-- 본문 -->
          <tr><td style="padding:26px 24px 8px;">
            <div style="font-size:20px;font-weight:800;color:#1a1a1a;">${_escapeHtml(lbl.greeting(userName || ''))}</div>
            <p style="font-size:14px;color:#555555;line-height:1.55;margin:8px 0 0;">${lbl.intro}</p>
          </td></tr>
          <!-- 피부타입 카드 -->
          <tr><td style="padding:18px 24px 0;">
            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:${c.light};border:1px solid ${c.border};border-radius:14px;">
              <tr><td style="padding:20px 22px;text-align:center;">
                <div style="font-size:34px;line-height:1;">${emoji}</div>
                <div style="font-size:11px;font-weight:700;letter-spacing:1px;color:${c.text};margin:8px 0 2px;">${lbl.typeLabel}</div>
                <div style="font-size:22px;font-weight:800;color:${c.text};">${_escapeHtml(typeName)}</div>
                <p style="font-size:13px;color:#666666;line-height:1.55;margin:10px 0 0;">${_escapeHtml(desc)}</p>
                ${concernBlock}
              </td></tr>
            </table>
          </td></tr>
          <!-- 루틴 -->
          <tr><td style="padding:6px 24px 0;">
            <div style="font-size:13px;font-weight:800;letter-spacing:.5px;color:#1a1a1a;margin:20px 0 0;">🧴 ${lbl.routineLabel}</div>
            ${section(lbl.am, _recommendedProductListAM, true)}
            ${section(lbl.pm, _recommendedProductListPM, false)}
          </td></tr>
          <!-- CTA -->
          <tr><td style="padding:18px 24px 26px;">
            <a href="https://21hermosa.es" target="_blank" style="display:block;background:${c.main};color:#ffffff;text-decoration:none;text-align:center;font-size:16px;font-weight:800;padding:16px;border-radius:12px;">${lbl.cta}</a>
          </td></tr>
          <!-- 푸터 -->
          <tr><td style="background:#f4f5f8;padding:18px 24px;text-align:center;">
            <div style="font-size:12px;color:#999999;">© 2026 21hermosa Parafarmacia · <a href="https://21hermosa.es" style="color:${c.main};text-decoration:none;">21hermosa.es</a></div>
            <div style="font-size:12px;color:#bbbbbb;margin-top:4px;">@21hermosa.es</div>
          </td></tr>
        </table>
      </td></tr>
    </table>
  </div>`;
}

// Klaviyo Flow 템플릿에서 반복 출력할 수 있는 제품 배열 (이미지/링크/가격 포함)
function _buildKlaviyoRoutine(rows) {
  return (rows || []).map(r => ({
    step:    r.step,
    type:    r.stepName || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[r.step] || `Paso ${r.step}`,
    brand:   r.brand || '',
    name:    r.productName || '',
    price:   r.price || '',
    image:   r.image || '',
    url:     r.url || ''
  }));
}

async function subscribeEmail() {
  const input = document.getElementById('email-cta-input');
  const btn   = document.getElementById('btn-email-send');
  const cta   = document.getElementById('email-result-cta');
  if (!input || !btn) return;

  const email = input.value.trim();
  // 간단한 이메일 형식 검증
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    alert(i18n[currentLang]['email_cta_invalid']);
    input.focus();
    return;
  }

  const originalLabel = btn.textContent;
  btn.disabled = true;
  input.disabled = true;
  btn.textContent = i18n[currentLang]['email_cta_sending'];

  // 추천 제품(낮/밤)이 아직 안 불렸으면 먼저 로드
  try { await _prefetchBothTabs(); } catch (e) { /* 폴백: 제품 없이 진행 */ }

  // 마케팅 동의 (분리형): 결과 메일 발송은 요청 이행이라 항상 진행,
  // 체크박스는 '마케팅 리스트 등록 동의'만 좌우한다.
  const consentEl = document.getElementById('email-cta-consent');
  const marketingConsent = !!(consentEl && consentEl.checked);

  const concernRaw = answers['q5_concern'];
  const concernArr = Array.isArray(concernRaw) ? concernRaw : (concernRaw ? [concernRaw] : []);
  const concernNames = concernArr.map(cc => CONCERN_NAMES[currentLang]?.[cc] || cc).join(', ');

  const skinKeyForSubj = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
  const subjTypeName = i18n[currentLang][`skin_${skinKeyForSubj}`] || '';
  const subject = currentLang === 'ko'
    ? `${userName || ''}님의 맞춤 K-Beauty 루틴 💌 (${subjTypeName})`
    : currentLang === 'en'
      ? `${userName || 'Your'} personalized K-Beauty routine 💌 (${subjTypeName})`
      : `Tu rutina K-Beauty personalizada 💌 (${subjTypeName})`;

  const leadData = {
    name:         userName || '',
    email:        email,
    subject:      subject,
    skinType:     detectedSkinType,
    concern:      concernNames,
    routine_text: _buildRoutineText(),
    email_body:   _buildRoutineEmailHtml()
  };

  // 1) 구독자 이메일을 Google Sheets 에 기록 (구독 리스트 적재)
  sendToGoogleSheets({
    name:          userName || '',
    email:         email,
    age:           userAge,
    gender:        answers['q_gender'] || '',
    skinType:      detectedSkinType,
    concern:       concernArr,
    safetyFilters: answers['q7_safety_filters'] || [],
    sunscreen:     answers['q8_sunscreen'] || '',
    lang:          currentLang,
    source:        'email_optin',
    marketingConsent: marketingConsent ? 'SÍ / 동의' : 'NO',
    recommendedProducts: _buildRoutineText().replace(/\n/g, ' | ')
  });

  const showSuccess = () => {
    if (!cta) return;
    cta.innerHTML = `<p class="email-cta-success">✅ ${i18n[currentLang]['email_sent_ok']}</p>`;
  };
  let settled = false;
  const done = () => { if (settled) return; settled = true; showSuccess(); };

  // 2) 결과 메일 발송 — Klaviyo 우선, 미설정 시 EmailJS 폴백
  if (klaviyoConfigured()) {
    const skinKey = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
    const profile = {
      email:      email,
      first_name: userName || '',
      properties: {
        skin_type:     subjTypeName,
        skin_type_key: detectedSkinType,
        skin_desc:     i18n[currentLang][`desc_${skinKey}`] || '',
        concerns:      concernArr.map(cc => CONCERN_NAMES[currentLang]?.[cc] || cc),
        age:           userAge,
        lang:          currentLang
      }
    };
    const lbl    = _emailLabels();
    const colors = SKIN_TYPE_COLORS[detectedSkinType] || SKIN_TYPE_COLORS.combination;
    const prof   = SKIN_TYPE_PROFILES[detectedSkinType] || {};
    const eventProps = {
      skin_type:    subjTypeName,
      skin_desc:    i18n[currentLang][`desc_${skinKey}`] || '',
      skin_emoji:   prof.emoji || '✨',
      concerns:     concernNames,
      am_routine:   _buildKlaviyoRoutine(_recommendedProductListAM),
      pm_routine:   _buildKlaviyoRoutine(_recommendedProductListPM),
      store_link:   'https://21hermosa.es',
      lang:         currentLang,
      // 피부타입별 테마 색상 (템플릿 인라인 스타일에서 사용)
      color_main:   colors.main,
      color_light:  colors.light,
      color_border: colors.border,
      color_text:   colors.text,
      // 현지화 라벨 (ES/EN/KO 자동) — 템플릿은 그대로 출력만 하면 됨
      greeting:      lbl.greeting(userName || ''),
      intro_text:    lbl.intro.replace(/<\/?b>/g, ''),
      type_label:    lbl.typeLabel,
      routine_label: lbl.routineLabel,
      am_label:      lbl.am,
      pm_label:      lbl.pm,
      concern_label: lbl.concernLabel,
      buy_label:     lbl.buy,
      cta_label:     lbl.cta,
      // 메일 제목 / 미리보기 텍스트 (현지화 — Klaviyo 제목칸에 {{ event.email_subject }})
      email_subject: subject,
      email_preview: currentLang === 'ko'
        ? '피부 진단 결과와 5단계 K-뷰티 루틴이 안에 있어요 💧'
        : currentLang === 'en'
          ? 'Your skin diagnosis and 5-step K-Beauty routine inside 💧'
          : 'Tu diagnóstico de piel y tu rutina K-Beauty de 5 pasos, dentro 💧'
    };
    // 'Completed Skin Quiz' 이벤트 → 결과 메일 Flow 트리거 (요청 이행, 항상 발송)
    sendKlaviyoEvent(profile, eventProps);
    // 마케팅 동의 시에만 리스트 구독 (더블옵트인은 Klaviyo가 처리)
    if (marketingConsent) subscribeKlaviyo(email, userName || '');
    done();
  } else {
    // 폴백: Klaviyo 키 미입력 시 기존 EmailJS 로 결과 메일 발송
    sendEmailJS(leadData, done, done);
    setTimeout(done, 1200);
  }
}

// ==================== 11a. 낮/밤 제품 사전 로드 (이미지 저장용) ====================
async function _prefetchBothTabs() {
  if (_recommendedProductListAM.length > 0 && _recommendedProductListPM.length > 0) return;
  const concernVal   = answers['q5_concern'];
  const concernArr   = Array.isArray(concernVal) ? concernVal : (concernVal ? [concernVal] : []);
  const safetyOpts   = answers['q7_safety_filters'] || [];
  const sunType      = answers['q8_sunscreen'];
  const makeupUsed   = answers['q9_makeup'];
  const experience   = answers['q10_experience'];

  // 메인 + 보완(2순위 집중 세럼 포함) 작업 목록 — 결과 화면과 동일 구성
  const buildJobs = (isAM) => {
    const mp = _buildStepPlan(isAM);
    const maxD = Math.max(...mp.map(j => j.displayNum), 0);
    return [...mp.map(j => ({ ...j, extra: false })), ..._buildExtraJobs(isAM, concernArr, maxD)];
  };
  const amJobs = buildJobs(true);
  const pmJobs = buildJobs(false);

  const planToList = (results, lang) => results
    .filter(r => r.best)
    .map(r => ({
      step: r.displayNum,
      stepName: r.label || (STEP_TYPE_NAMES[lang] || STEP_TYPE_NAMES.es)[r.stepNum] || `Paso ${r.displayNum}`,
      brand: r.best.brand,
      productName: r.best.name,
      image: r.best.imageUrl || '',
      price: r.best.price || '',
      url: r.best.link || ''
    }));

  if (window.shopifyQuiz && window.shopifyQuiz.isConfigured()) {
    try {
      const fetchJobs = (jobs, isAM) => Promise.all(jobs.map(j =>
        window.shopifyQuiz.getProductsForStep(j.stepNum, isAM, detectedSkinType, j.concernOverride || concernVal, userAge, safetyOpts,
          j.stepNum === 5 ? sunType : null, j.cleanserKind || null,
          j.variant || null, j.stepNum === 5 ? makeupUsed : null, experience)
          .then(r => ({ ...j, ...r }))));
      const [amRes, pmRes] = await Promise.all([fetchJobs(amJobs, true), fetchJobs(pmJobs, false)]);
      _dedupSecondaryTreatment(amRes);
      _dedupSecondaryTreatment(pmRes);
      _filterIrrelevantTreatment(amRes, concernArr[0], concernArr[1], userAge);
      _filterIrrelevantTreatment(pmRes, concernArr[0], concernArr[1], userAge);
      if (_recommendedProductListAM.length === 0) _recommendedProductListAM = planToList(amRes, currentLang);
      if (_recommendedProductListPM.length === 0) _recommendedProductListPM = planToList(pmRes, currentLang);
    } catch (e) { console.error('[Prefetch]', e); }
  } else if (window.productsDatabase) {
    const all = window.productsDatabase.getProducts();
    const pickProduct = (j, isAM, excludeId) => {
      let cands = all.filter(p => p.step === j.stepNum && (isAM ? p.isDia : p.isNoche));
      if (safetyOpts.includes('pregnancy')) cands = cands.filter(p => p.pregnancySafe);
      if (safetyOpts.includes('fragrance'))  cands = cands.filter(p => p.fragranceFree);
      if (detectedSkinType === 'sensitive') { const ff = cands.filter(p => p.fragranceFree); if (ff.length) cands = ff; }
      if (j.stepNum === 5 && makeupUsed === 'yes') {
        const noStick = cands.filter(p => p.sunscreenTexture !== 'stick');
        if (noStick.length) cands = noStick;
      }
      if (j.stepNum === 1) {
        if (j.cleanserKind === 'oil') cands = cands.filter(p => p.cleanserType === 'oil');
        else                          cands = cands.filter(p => p.cleanserType !== 'oil');
      }
      if (j.stepNum === 4) {
        if (j.variant === 'treatment') cands = cands.filter(p => p.isTreatment);
        else                           cands = cands.filter(p => !p.isTreatment);
      }
      if (excludeId) cands = cands.filter(p => p.id !== excludeId);
      if (!cands.length) return null;
      const c1 = j.concernOverride || concernArr[0];
      const c2 = j.concernOverride ? null : concernArr[1];
      const scored = cands.map(p => ({ p,
        score: skinquizScore(p, detectedSkinType, c1, c2, userAge, j.stepNum, experience)
      })).sort((a,b) => b.score - a.score);
      return scored[0].p;
    };
    const getRows = (jobs, isAM) => {
      let mainSerumId = null;
      const rows = [];
      jobs.forEach(j => {
        const p = pickProduct(j, isAM, j.concernOverride ? mainSerumId : null);
        if (!p) return;
        if (!j.extra && j.stepNum === 3) mainSerumId = p.id;
        rows.push({ step: j.displayNum, stepName: j.label || (STEP_TYPE_NAMES[currentLang]||STEP_TYPE_NAMES.es)[j.stepNum], brand: p.brand, productName: p.name, image: p.imageUrl || '', price: p.price || '', url: p.link || '' });
      });
      return rows;
    };
    if (_recommendedProductListAM.length === 0) _recommendedProductListAM = getRows(amJobs, true);
    if (_recommendedProductListPM.length === 0) _recommendedProductListPM = getRows(pmJobs, false);
  }
}

// ==================== 11b. 결과 이미지 저장 ====================
function _wrapText(ctx, text, maxW, maxLines) {
  if (!maxLines) maxLines = 2;
  const words = text.split(' ');
  const lines = [];
  let cur = '';
  for (let i = 0; i < words.length; i++) {
    const test = cur ? cur + ' ' + words[i] : words[i];
    if (ctx.measureText(test).width > maxW && cur) {
      lines.push(cur);
      if (lines.length >= maxLines) return lines;
      cur = words[i];
    } else {
      cur = test;
    }
  }
  if (cur) lines.push(cur);
  return lines;
}

function _squircle(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.arcTo(x + w, y, x + w, y + r, r);
  ctx.lineTo(x + w, y + h - r);
  ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h);
  ctx.arcTo(x, y + h, x, y + h - r, r);
  ctx.lineTo(x, y + r);
  ctx.arcTo(x, y, x + r, y, r);
  ctx.closePath();
}

function _showShareModal(canvas) {
  const existing = document.getElementById('share-modal');
  if (existing) existing.remove();

  const dataUrl = canvas.toDataURL('image/png');
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const hintText = currentLang === 'ko'
    ? (isMobile ? '📱 이미지를 길게 눌러 저장하세요' : '🖥 이미지를 우클릭 → 다른 이름으로 저장')
    : (currentLang === 'en'
      ? (isMobile ? '📱 Long-press the image to save' : '🖥 Right-click the image → Save as')
      : (isMobile ? '📱 Mantén pulsada la imagen para guardar' : '🖥 Clic derecho → Guardar imagen como'));
  const dlText = currentLang === 'ko' ? '⬇ 다운로드' : (currentLang === 'en' ? '⬇ Download' : '⬇ Descargar');
  const titleText = currentLang === 'ko' ? '결과 이미지' : (currentLang === 'en' ? 'Result Image' : 'Imagen de Resultado');

  const modal = document.createElement('div');
  modal.id = 'share-modal';
  modal.innerHTML = `
    <div class="share-modal-overlay" onclick="document.getElementById('share-modal').remove()">
      <div class="share-modal-box" onclick="event.stopPropagation()">
        <div class="share-modal-header">
          <span>${titleText}</span>
          <button class="share-modal-close" onclick="document.getElementById('share-modal').remove()">✕</button>
        </div>
        <img class="share-modal-img" src="${dataUrl}" alt="Skin Quiz Result">
        <p class="share-modal-hint">${hintText}</p>
        <a class="share-modal-download" href="${dataUrl}" download="21hermosa-skin-result.png">${dlText}</a>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
}

async function downloadResultImage() {
  const btn = document.querySelector('.btn-save-image');
  if (btn) { btn.disabled = true; btn.textContent = '⏳'; }
  try {
    await _prefetchBothTabs();
    _renderShareCard(_recommendedProductListAM, _recommendedProductListPM);
  } catch(e) { console.error('[Image]', e); }
  finally { if (btn) { btn.disabled = false; btn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg> ${i18n[currentLang]['save_image']}`; } }
}

function _renderShareCard(amRows, pmRows) {
  const W    = 1080;
  const PAD  = 48;
  const FONT = '"Noto Sans KR","Apple SD Gothic Neo","Malgun Gothic","Segoe UI",-apple-system,sans-serif';

  const c       = SKIN_TYPE_COLORS[detectedSkinType] || SKIN_TYPE_COLORS.combination;
  const skinKey = detectedSkinType === 'combination' ? 'combo' : detectedSkinType;
  const typeName = i18n[currentLang][`skin_${skinKey}`] || detectedSkinType;
  const profile  = SKIN_TYPE_PROFILES[detectedSkinType] || {};
  const emoji    = profile.emoji || '✨';
  const concernArr = Array.isArray(answers['q5_concern'])
    ? answers['q5_concern']
    : (answers['q5_concern'] ? [answers['q5_concern']] : []);
  const concernNames = concernArr.map(c2 => CONCERN_NAMES[currentLang]?.[c2] || c2).join(' · ');

  const BADGE_CX = PAD + 26;
  const BADGE_R  = 20;
  const TX       = BADGE_CX + BADGE_R + 18;  // = PAD + 84
  const TW       = W - TX - PAD;

  const tmp = document.createElement('canvas').getContext('2d');
  tmp.font = `bold 34px ${FONT}`;

  // ★ 언어 버그 수정: 캐시 무시하고 currentLang 로 stepName 재계산
  const prepRows = (rows) => rows.map(r => {
    const stepName = r.stepName || (STEP_TYPE_NAMES[currentLang] || STEP_TYPE_NAMES.es)[r.step] || `Paso ${r.step}`;
    const lines    = _wrapText(tmp, r.productName, TW, 2);
    return { ...r, stepName, lines, rh: 100 + (lines.length > 1 ? 42 : 0) };
  });
  const amData = prepRows(amRows);
  const pmData = prepRows(pmRows);
  const rowsH  = (d) => d.reduce((s, r) => s + r.rh + 10, 0);

  const HEADER_H = 168;
  const HERO_H   = 240;
  const SEC_H    = 58;
  const FOOTER_H = 128;
  const GAP      = 20;
  const H = HEADER_H + GAP + HERO_H + GAP
          + SEC_H + 10 + rowsH(amData) + GAP
          + SEC_H + 10 + rowsH(pmData) + GAP
          + FOOTER_H;

  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  // ── 배경 (밝은 오프화이트)
  ctx.fillStyle = '#F8F9FC';
  ctx.fillRect(0, 0, W, H);

  // ── 헤더
  ctx.fillStyle = c.main;
  ctx.fillRect(0, 0, W, HEADER_H);
  const hg = ctx.createLinearGradient(0, 0, W, HEADER_H);
  hg.addColorStop(0, 'rgba(255,255,255,0.14)'); hg.addColorStop(1, 'rgba(0,0,0,0.08)');
  ctx.fillStyle = hg; ctx.fillRect(0, 0, W, HEADER_H);
  ctx.fillStyle = '#FFF'; ctx.textAlign = 'center';
  ctx.font = `bold 68px ${FONT}`;
  ctx.fillText('21hermosa', W/2, 84);
  ctx.font = `300 32px ${FONT}`;
  ctx.fillStyle = 'rgba(255,255,255,0.76)';
  ctx.fillText('K-Beauty Skin Diagnosis', W/2, 140);

  // ── 히어로 카드
  let y = HEADER_H + GAP;
  ctx.shadowColor='rgba(0,0,0,0.07)'; ctx.shadowBlur=20; ctx.shadowOffsetY=4;
  ctx.fillStyle='#FFF';
  _squircle(ctx, PAD, y, W-PAD*2, HERO_H, 22); ctx.fill();
  ctx.shadowColor='transparent'; ctx.shadowBlur=0; ctx.shadowOffsetY=0;
  // 상단 얇은 컬러 라인
  ctx.fillStyle = c.main; ctx.fillRect(PAD, y, W-PAD*2, 4);

  ctx.font=`76px serif`; ctx.textAlign='center';
  ctx.fillText(emoji, W/2, y+92);
  ctx.fillStyle=c.text; ctx.font=`bold 54px ${FONT}`;
  ctx.fillText(typeName, W/2, y+170);
  if (concernNames) {
    ctx.fillStyle='#AAAAAA'; ctx.font=`300 28px ${FONT}`;
    ctx.fillText(concernNames, W/2, y+214);
  }

  y += HERO_H + GAP;

  // ── 섹션 그리기 (AM/PM 공통)
  const drawSection = (data, isAM) => {
    const amBg = c.main;
    const pmBg = '#3D4F63';
    const bg   = isAM ? amBg : pmBg;
    const secIcon = isAM ? '☀️' : '🌙';
    const secText = isAM
      ? (currentLang==='ko' ? '낮 루틴 (AM)' : currentLang==='en' ? 'Morning Routine (AM)' : 'Rutina de Mañana (AM)')
      : (currentLang==='ko' ? '저녁 루틴 (PM)' : currentLang==='en' ? 'Night Routine (PM)' : 'Rutina de Noche (PM)');

    // 섹션 헤더 배너
    ctx.fillStyle = bg;
    _squircle(ctx, PAD, y, W-PAD*2, SEC_H, 14); ctx.fill();
    ctx.fillStyle = '#FFF'; ctx.font = `bold 30px ${FONT}`; ctx.textAlign = 'left';
    ctx.fillText(secIcon + '  ' + secText, PAD + 26, y + 39);
    y += SEC_H + 10;

    // 제품 카드
    data.forEach(({ step, stepName, brand, lines, rh }) => {
      // 카드 (그림자 없이 순수 흰색 → 더 깔끔)
      ctx.fillStyle = '#FFF';
      _squircle(ctx, PAD, y, W-PAD*2, rh, 14); ctx.fill();

      // 카드 상단 얇은 구분선 (배경색으로)
      ctx.fillStyle = '#F8F9FC';
      ctx.fillRect(PAD + TX - PAD, y, W - PAD*2 - (TX - PAD), 1);

      // 단계 뱃지: 연한 배경 원 + 컬러 원 + 숫자
      const cy = y + rh / 2;
      ctx.fillStyle = isAM ? c.light : '#E8ECF2';
      ctx.beginPath(); ctx.arc(BADGE_CX, cy, BADGE_R + 6, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle = bg;
      ctx.beginPath(); ctx.arc(BADGE_CX, cy, BADGE_R, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle = '#FFF'; ctx.font = `bold 22px ${FONT}`; ctx.textAlign = 'center';
      ctx.fillText(String(step), BADGE_CX, cy + 8);

      // 메타: 단계유형 · 브랜드
      ctx.fillStyle = '#BBBBBB'; ctx.font = `400 22px ${FONT}`; ctx.textAlign = 'left';
      ctx.fillText(stepName + (brand ? '  ·  ' + brand : ''), TX, y + 28);

      // 제품명 (굵게, 최대 2줄)
      ctx.fillStyle = '#1A1A1A'; ctx.font = `bold 34px ${FONT}`;
      lines.forEach((ln, li) => ctx.fillText(ln, TX, y + 64 + li * 42));

      y += rh + 10;
    });
  };

  drawSection(amData, true);
  y += GAP;
  drawSection(pmData, false);
  y += GAP;

  // ── 푸터
  ctx.fillStyle = c.main; ctx.fillRect(0, y, W, FOOTER_H);
  const fg = ctx.createLinearGradient(0, y, 0, y+FOOTER_H);
  fg.addColorStop(0, 'rgba(0,0,0,0.14)'); fg.addColorStop(1, 'rgba(0,0,0,0.02)');
  ctx.fillStyle = fg; ctx.fillRect(0, y, W, FOOTER_H);
  ctx.fillStyle = '#FFF'; ctx.textAlign = 'center';
  ctx.font = `bold 44px ${FONT}`;
  ctx.fillText('21hermosa.es', W/2, y+56);
  ctx.font = `300 27px ${FONT}`; ctx.fillStyle = 'rgba(255,255,255,0.70)';
  ctx.fillText('@21hermosa.es  ·  K-Beauty', W/2, y+98);

  _showShareModal(canvas);
}

// ==================== 12. URL 쿼리 파라미터 연동 결과 재생성 ====================
window.onload = function() {
  const params = new URLSearchParams(window.location.search);
  const paramName = params.get('name');
  const paramType = params.get('type');
  const paramConcern = params.get('concern');

  if (paramName && paramType && paramConcern) {
    userName = decodeURIComponent(paramName);
    detectedSkinType = paramType;
    answers['q5_concern'] = paramConcern.includes(',') ? paramConcern.split(',') : [paramConcern];
    
    document.getElementById('intro-view').style.display = 'none';
    document.getElementById('result-view').style.display = 'flex';
    renderResult();
  }
};
